import type { SVGProps } from "react";

export const System = (props: SVGProps<SVGSVGElement>) => (
	<svg
		className="h-full w-full"
		fill="none"
		viewBox="0 0 200 132"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_4931_10045)">
			<path
				d="M0 10C0 4.47715 4.47715 0 10 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H10C4.47716 132 0 127.523 0 122V10Z"
				fill="#F5F5F5"
			/>
			<g clipPath="url(#clip1_4931_10045)">
				<path
					d="M0 10C0 4.47715 4.47715 0 10 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H10C4.47716 132 0 127.523 0 122V10Z"
					fill="#F5F5F5"
				/>
				<rect
					fill="#E9EAEB"
					height="1.25001"
					transform="translate(13.125 117.5) rotate(-90)"
					width="117.5"
				/>
				<rect
					fill="#E9EAEB"
					height="1.25"
					transform="translate(0 13.125)"
					width="200"
				/>
				<rect
					fill="#E9EAEB"
					height="1.25001"
					transform="translate(185.625 117.5) rotate(-90)"
					width="117.5"
				/>
				<g clipPath="url(#clip2_4931_10045)">
					<rect
						fill="white"
						height="130"
						rx="5"
						width="175"
						x="12.5"
						y="12.5"
					/>
					<mask fill="white" id="path-6-inside-1_4931_10045">
						<path d="M12.5 17.5C12.5 14.7386 14.7386 12.5 17.5 12.5H182.5C185.261 12.5 187.5 14.7386 187.5 17.5V23.125H12.5V17.5Z" />
					</mask>
					<path
						d="M12.5 17.5C12.5 14.7386 14.7386 12.5 17.5 12.5H182.5C185.261 12.5 187.5 14.7386 187.5 17.5V23.125H12.5V17.5Z"
						fill="#FAFAFA"
					/>
					<path
						d="M12.5 12.5H187.5H12.5ZM187.5 23.75H12.5V22.5H187.5V23.75ZM12.5 23.125V12.5V23.125ZM187.5 12.5V23.125V12.5Z"
						fill="#E9EAEB"
						mask="url(#path-6-inside-1_4931_10045)"
					/>
					<g filter="url(#filter0_i_4931_10045)">
						<circle cx="18.75" cy="18.125" fill="#EE6A5F" r="1.875" />
					</g>
					<circle
						cx="18.75"
						cy="18.125"
						r="1.79688"
						stroke="#CE5347"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter1_i_4931_10045)">
						<circle cx="25" cy="18.125" fill="#F5BD4F" r="1.875" />
					</g>
					<circle
						cx="25"
						cy="18.125"
						r="1.79688"
						stroke="#D6A243"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter2_i_4931_10045)">
						<circle cx="31.25" cy="18.125" fill="#61C454" r="1.875" />
					</g>
					<circle
						cx="31.25"
						cy="18.125"
						r="1.79688"
						stroke="#58A942"
						strokeWidth="0.15625"
					/>
					<rect
						fill="#FAFAFA"
						height="45"
						rx="3.75"
						width="117.5"
						x="63.75"
						y="50.3125"
					/>
					<mask
						height="34"
						id="mask0_4931_10045"
						maskUnits="userSpaceOnUse"
						style={{ maskType: "alpha" }}
						width="105"
						x="70"
						y="57"
					>
						<rect
							fill="url(#paint0_linear_4931_10045)"
							height="32.5"
							transform="translate(70 57.8125)"
							width="105"
						/>
					</mask>
					<g mask="url(#mask0_4931_10045)">
						<path
							d="M92.4617 80.1255L81.2734 83.5912C81.253 83.5975 81.2321 83.6017 81.211 83.6037L70.2824 84.6602C70.1222 84.6757 70 84.8103 70 84.9712V87.1875C70 87.3601 70.1399 87.5 70.3125 87.5H174.688C174.86 87.5 175 87.3601 175 87.1875V62.983C175 62.8104 174.86 62.6705 174.688 62.6705H171.303C171.268 62.6705 171.233 62.6646 171.2 62.653L160.128 58.7945C160.046 58.7661 159.957 58.7727 159.88 58.8127L148.793 64.6081C148.765 64.6231 148.734 64.6335 148.702 64.639L137.541 66.5838C137.514 66.5885 137.487 66.5968 137.463 66.6083L126.339 71.7769C126.281 71.8038 126.216 71.8123 126.153 71.8014L115.071 69.8704C115.024 69.8622 114.976 69.8649 114.931 69.8781L103.791 73.113C103.764 73.121 103.738 73.1326 103.714 73.1477L92.5341 80.0925C92.5115 80.1065 92.4871 80.1176 92.4617 80.1255Z"
							fill="#7F56D9"
							opacity="0.1"
						/>
					</g>
					<path
						d="M70 84.6875L81.211 83.6037C81.2321 83.6017 81.253 83.5974 81.2734 83.5912L92.4617 80.1255C92.4871 80.1176 92.5115 80.1065 92.5341 80.0925L103.714 73.1477C103.738 73.1326 103.764 73.121 103.791 73.113L114.931 69.8781C114.976 69.8649 115.024 69.8622 115.071 69.8704L126.154 71.8014C126.216 71.8123 126.281 71.8038 126.339 71.7769L137.463 66.6083C137.487 66.5968 137.514 66.5885 137.541 66.5838L148.702 64.639C148.734 64.6335 148.765 64.6231 148.793 64.6081L159.88 58.8127C159.957 58.7727 160.046 58.7661 160.128 58.7945L171.2 62.653C171.233 62.6646 171.268 62.6705 171.303 62.6705H175"
						stroke="#7F56D9"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="0.625"
					/>
					<path
						d="M63.75 104.062C63.75 101.991 65.4289 100.312 67.5 100.312H177.5C179.571 100.312 181.25 101.991 181.25 104.063V141.563C181.25 143.634 179.571 145.312 177.5 145.312H67.5C65.4289 145.312 63.75 143.634 63.75 141.562V104.062Z"
						fill="#FAFAFA"
					/>
					<rect
						fill="#F5F5F5"
						height="3.75"
						rx="1.25"
						width="65"
						x="63.75"
						y="41.5625"
					/>
					<path
						d="M63.8916 31.375H65.0757L66.2158 33.5283H66.2646L67.4048 31.375H68.5889L66.7651 34.6074V36.375H65.7153V34.6074L63.8916 31.375ZM70.0555 36.4482C69.6763 36.4482 69.3483 36.3677 69.0717 36.2065C68.7966 36.0438 68.5842 35.8175 68.4344 35.5278C68.2847 35.2365 68.2098 34.8988 68.2098 34.5146C68.2098 34.1273 68.2847 33.7887 68.4344 33.499C68.5842 33.2077 68.7966 32.9814 69.0717 32.8203C69.3483 32.6576 69.6763 32.5762 70.0555 32.5762C70.4348 32.5762 70.7619 32.6576 71.037 32.8203C71.3137 32.9814 71.5269 33.2077 71.6766 33.499C71.8264 33.7887 71.9012 34.1273 71.9012 34.5146C71.9012 34.8988 71.8264 35.2365 71.6766 35.5278C71.5269 35.8175 71.3137 36.0438 71.037 36.2065C70.7619 36.3677 70.4348 36.4482 70.0555 36.4482ZM70.0604 35.6426C70.233 35.6426 70.377 35.5937 70.4926 35.4961C70.6081 35.3968 70.6952 35.2617 70.7538 35.0908C70.814 34.9199 70.8441 34.7254 70.8441 34.5073C70.8441 34.2892 70.814 34.0947 70.7538 33.9238C70.6952 33.7529 70.6081 33.6178 70.4926 33.5186C70.377 33.4193 70.233 33.3696 70.0604 33.3696C69.8863 33.3696 69.7398 33.4193 69.621 33.5186C69.5038 33.6178 69.4151 33.7529 69.3549 33.9238C69.2963 34.0947 69.267 34.2892 69.267 34.5073C69.267 34.7254 69.2963 34.9199 69.3549 35.0908C69.4151 35.2617 69.5038 35.3968 69.621 35.4961C69.7398 35.5937 69.8863 35.6426 70.0604 35.6426ZM74.9823 34.7783V32.625H76.0223V36.375H75.0238V35.6938H74.9847C74.9001 35.9136 74.7593 36.0902 74.5624 36.2236C74.3671 36.3571 74.1286 36.4238 73.847 36.4238C73.5964 36.4238 73.3759 36.3669 73.1854 36.2529C72.995 36.139 72.8461 35.9771 72.7386 35.7671C72.6329 35.5571 72.5791 35.3057 72.5775 35.0127V32.625H73.6176V34.8271C73.6192 35.0485 73.6786 35.2235 73.7958 35.3521C73.913 35.4806 74.07 35.5449 74.267 35.5449C74.3923 35.5449 74.5095 35.5164 74.6185 35.4595C74.7276 35.4009 74.8155 35.3146 74.8822 35.2007C74.9506 35.0868 74.9839 34.946 74.9823 34.7783ZM76.8542 36.375V32.625H77.8625V33.2793H77.9016C77.97 33.0465 78.0847 32.8708 78.2458 32.752C78.407 32.6315 78.5925 32.5713 78.8025 32.5713C78.8546 32.5713 78.9107 32.5745 78.9709 32.5811C79.0312 32.5876 79.0841 32.5965 79.1296 32.6079V33.5308C79.0808 33.5161 79.0133 33.5031 78.927 33.4917C78.8407 33.4803 78.7618 33.4746 78.6902 33.4746C78.5372 33.4746 78.4005 33.508 78.28 33.5747C78.1612 33.6398 78.0668 33.731 77.9968 33.8481C77.9285 33.9653 77.8943 34.1004 77.8943 34.2534V36.375H76.8542ZM82.6404 36.436C82.3556 36.436 82.0976 36.3628 81.8665 36.2163C81.637 36.0682 81.4547 35.8509 81.3196 35.5645C81.1861 35.2764 81.1194 34.9232 81.1194 34.5049C81.1194 34.0752 81.1886 33.7179 81.3269 33.4331C81.4653 33.1466 81.6492 32.9326 81.8787 32.791C82.1098 32.6478 82.3629 32.5762 82.6379 32.5762C82.8479 32.5762 83.0229 32.612 83.1628 32.6836C83.3044 32.7536 83.4184 32.8415 83.5046 32.9473C83.5925 33.0514 83.6593 33.154 83.7048 33.2549H83.7366V31.375H84.7742V36.375H83.7488V35.7744H83.7048C83.656 35.8786 83.5868 35.9819 83.4973 36.0845C83.4094 36.1854 83.2947 36.2692 83.1531 36.3359C83.0131 36.4027 82.8422 36.436 82.6404 36.436ZM82.97 35.6084C83.1376 35.6084 83.2792 35.5628 83.3948 35.4717C83.512 35.3789 83.6015 35.2495 83.6633 35.0835C83.7268 34.9175 83.7585 34.723 83.7585 34.5C83.7585 34.277 83.7276 34.0833 83.6658 33.9189C83.6039 33.7546 83.5144 33.6276 83.3972 33.5381C83.28 33.4486 83.1376 33.4038 82.97 33.4038C82.7991 33.4038 82.655 33.4502 82.5378 33.543C82.4207 33.6357 82.3319 33.7643 82.2717 33.9287C82.2115 34.0931 82.1814 34.2835 82.1814 34.5C82.1814 34.7181 82.2115 34.911 82.2717 35.0786C82.3336 35.2446 82.4223 35.3748 82.5378 35.4692C82.655 35.562 82.7991 35.6084 82.97 35.6084ZM86.6986 36.4458C86.4594 36.4458 86.2461 36.4043 86.059 36.3213C85.8718 36.2367 85.7237 36.1121 85.6146 35.9478C85.5072 35.7817 85.4535 35.575 85.4535 35.3276C85.4535 35.1193 85.4917 34.9443 85.5682 34.8027C85.6447 34.6611 85.7489 34.5472 85.8807 34.4609C86.0126 34.3747 86.1623 34.3096 86.33 34.2656C86.4992 34.2217 86.6766 34.1908 86.8622 34.1729C87.0803 34.1501 87.2561 34.1289 87.3895 34.1094C87.523 34.0882 87.6198 34.0573 87.6801 34.0166C87.7403 33.9759 87.7704 33.9157 87.7704 33.8359V33.8213C87.7704 33.6667 87.7216 33.547 87.6239 33.4624C87.5279 33.3778 87.3912 33.3354 87.2137 33.3354C87.0266 33.3354 86.8776 33.377 86.767 33.46C86.6563 33.5413 86.583 33.6439 86.5472 33.7676L85.5853 33.6895C85.6342 33.4616 85.7302 33.2646 85.8734 33.0986C86.0166 32.931 86.2014 32.8024 86.4276 32.7129C86.6555 32.6217 86.9191 32.5762 87.2186 32.5762C87.427 32.5762 87.6263 32.6006 87.8168 32.6494C88.0088 32.6982 88.1789 32.7739 88.327 32.8765C88.4768 32.979 88.5948 33.1108 88.681 33.272C88.7673 33.4315 88.8104 33.6227 88.8104 33.8457V36.375H87.8241V35.855H87.7948C87.7346 35.9722 87.654 36.0755 87.5531 36.165C87.4522 36.2529 87.3309 36.3221 87.1893 36.3726C87.0477 36.4214 86.8842 36.4458 86.6986 36.4458ZM86.9965 35.728C87.1495 35.728 87.2845 35.6979 87.4017 35.6377C87.5189 35.5758 87.6109 35.4928 87.6776 35.3887C87.7443 35.2845 87.7777 35.1665 87.7777 35.0347V34.6367C87.7452 34.6579 87.7004 34.6774 87.6434 34.6953C87.5881 34.7116 87.5254 34.7271 87.4554 34.7417C87.3855 34.7547 87.3155 34.7669 87.2455 34.7783C87.1755 34.7881 87.112 34.797 87.0551 34.8052C86.933 34.8231 86.8264 34.8516 86.7352 34.8906C86.6441 34.9297 86.5733 34.9826 86.5228 35.0493C86.4724 35.1144 86.4471 35.1958 86.4471 35.2935C86.4471 35.4351 86.4984 35.5433 86.601 35.6182C86.7051 35.6914 86.837 35.728 86.9965 35.728ZM92.7374 33.6943L91.7853 33.7529C91.769 33.6715 91.734 33.5983 91.6803 33.5332C91.6266 33.4665 91.5558 33.4136 91.4679 33.3745C91.3816 33.3338 91.2783 33.3135 91.1578 33.3135C90.9967 33.3135 90.8608 33.3477 90.7501 33.416C90.6394 33.4827 90.5841 33.5723 90.5841 33.6846C90.5841 33.7741 90.6199 33.8498 90.6915 33.9116C90.7631 33.9735 90.886 34.0231 91.0602 34.0605L91.7389 34.1973C92.1035 34.2721 92.3753 34.3926 92.5543 34.5586C92.7334 34.7246 92.8229 34.9427 92.8229 35.2129C92.8229 35.4587 92.7504 35.6743 92.6056 35.8599C92.4624 36.0454 92.2654 36.1903 92.0148 36.2944C91.7657 36.397 91.4785 36.4482 91.153 36.4482C90.6565 36.4482 90.261 36.3449 89.9664 36.1382C89.6735 35.9299 89.5017 35.6466 89.4513 35.2886L90.4742 35.2349C90.5052 35.3862 90.58 35.5018 90.6989 35.5815C90.8177 35.6597 90.9698 35.6987 91.1554 35.6987C91.3377 35.6987 91.4842 35.6637 91.5948 35.5937C91.7072 35.5221 91.7641 35.4302 91.7657 35.3179C91.7641 35.2235 91.7242 35.1462 91.6461 35.0859C91.568 35.0241 91.4476 34.9769 91.2848 34.9443L90.6354 34.8149C90.2692 34.7417 89.9965 34.6147 89.8175 34.4341C89.6401 34.2534 89.5514 34.0231 89.5514 33.7432C89.5514 33.5023 89.6165 33.2948 89.7467 33.1206C89.8785 32.9465 90.0633 32.8122 90.3009 32.7178C90.5402 32.6234 90.8201 32.5762 91.1407 32.5762C91.6144 32.5762 91.9871 32.6763 92.2589 32.8765C92.5323 33.0767 92.6919 33.3493 92.7374 33.6943ZM94.5178 34.207V36.375H93.4778V31.375H94.4885V33.2866H94.5325C94.6171 33.0653 94.7538 32.8919 94.9426 32.7666C95.1314 32.6396 95.3682 32.5762 95.6531 32.5762C95.9135 32.5762 96.1405 32.6331 96.3342 32.7471C96.5295 32.8594 96.6809 33.0213 96.7883 33.2329C96.8974 33.4429 96.9511 33.6943 96.9495 33.9873V36.375H95.9094V34.1729C95.9111 33.9417 95.8525 33.7619 95.7336 33.6333C95.6165 33.5047 95.4521 33.4404 95.2405 33.4404C95.0989 33.4404 94.9736 33.4705 94.8645 33.5308C94.7571 33.591 94.6724 33.6789 94.6106 33.7944C94.5504 33.9084 94.5194 34.0459 94.5178 34.207ZM97.7875 36.375V31.375H98.8275V33.2549H98.8593C98.9048 33.154 98.9707 33.0514 99.057 32.9473C99.1449 32.8415 99.2588 32.7536 99.3988 32.6836C99.5404 32.612 99.7162 32.5762 99.9261 32.5762C100.2 32.5762 100.452 32.6478 100.683 32.791C100.914 32.9326 101.099 33.1466 101.237 33.4331C101.376 33.7179 101.445 34.0752 101.445 34.5049C101.445 34.9232 101.377 35.2764 101.242 35.5645C101.109 35.8509 100.926 36.0682 100.695 36.2163C100.466 36.3628 100.209 36.436 99.9237 36.436C99.7219 36.436 99.5502 36.4027 99.4086 36.3359C99.2686 36.2692 99.1538 36.1854 99.0643 36.0845C98.9748 35.9819 98.9065 35.8786 98.8593 35.7744H98.8129V36.375H97.7875ZM98.8055 34.5C98.8055 34.723 98.8365 34.9175 98.8983 35.0835C98.9602 35.2495 99.0497 35.3789 99.1669 35.4717C99.2841 35.5628 99.4265 35.6084 99.5941 35.6084C99.7634 35.6084 99.9066 35.562 100.024 35.4692C100.141 35.3748 100.23 35.2446 100.29 35.0786C100.352 34.911 100.383 34.7181 100.383 34.5C100.383 34.2835 100.353 34.0931 100.292 33.9287C100.232 33.7643 100.143 33.6357 100.026 33.543C99.9091 33.4502 99.765 33.4038 99.5941 33.4038C99.4248 33.4038 99.2816 33.4486 99.1644 33.5381C99.0489 33.6276 98.9602 33.7546 98.8983 33.9189C98.8365 34.0833 98.8055 34.277 98.8055 34.5ZM103.833 36.4482C103.454 36.4482 103.126 36.3677 102.849 36.2065C102.574 36.0438 102.362 35.8175 102.212 35.5278C102.062 35.2365 101.987 34.8988 101.987 34.5146C101.987 34.1273 102.062 33.7887 102.212 33.499C102.362 33.2077 102.574 32.9814 102.849 32.8203C103.126 32.6576 103.454 32.5762 103.833 32.5762C104.212 32.5762 104.539 32.6576 104.814 32.8203C105.091 32.9814 105.304 33.2077 105.454 33.499C105.604 33.7887 105.679 34.1273 105.679 34.5146C105.679 34.8988 105.604 35.2365 105.454 35.5278C105.304 35.8175 105.091 36.0438 104.814 36.2065C104.539 36.3677 104.212 36.4482 103.833 36.4482ZM103.838 35.6426C104.01 35.6426 104.154 35.5937 104.27 35.4961C104.386 35.3968 104.473 35.2617 104.531 35.0908C104.591 34.9199 104.622 34.7254 104.622 34.5073C104.622 34.2892 104.591 34.0947 104.531 33.9238C104.473 33.7529 104.386 33.6178 104.27 33.5186C104.154 33.4193 104.01 33.3696 103.838 33.3696C103.664 33.3696 103.517 33.4193 103.398 33.5186C103.281 33.6178 103.193 33.7529 103.132 33.9238C103.074 34.0947 103.044 34.2892 103.044 34.5073C103.044 34.7254 103.074 34.9199 103.132 35.0908C103.193 35.2617 103.281 35.3968 103.398 35.4961C103.517 35.5937 103.664 35.6426 103.838 35.6426ZM107.424 36.4458C107.185 36.4458 106.972 36.4043 106.785 36.3213C106.597 36.2367 106.449 36.1121 106.34 35.9478C106.233 35.7817 106.179 35.575 106.179 35.3276C106.179 35.1193 106.217 34.9443 106.294 34.8027C106.37 34.6611 106.475 34.5472 106.606 34.4609C106.738 34.3747 106.888 34.3096 107.056 34.2656C107.225 34.2217 107.402 34.1908 107.588 34.1729C107.806 34.1501 107.982 34.1289 108.115 34.1094C108.249 34.0882 108.346 34.0573 108.406 34.0166C108.466 33.9759 108.496 33.9157 108.496 33.8359V33.8213C108.496 33.6667 108.447 33.547 108.35 33.4624C108.254 33.3778 108.117 33.3354 107.939 33.3354C107.752 33.3354 107.603 33.377 107.493 33.46C107.382 33.5413 107.309 33.6439 107.273 33.7676L106.311 33.6895C106.36 33.4616 106.456 33.2646 106.599 33.0986C106.742 32.931 106.927 32.8024 107.153 32.7129C107.381 32.6217 107.645 32.5762 107.944 32.5762C108.153 32.5762 108.352 32.6006 108.542 32.6494C108.735 32.6982 108.905 32.7739 109.053 32.8765C109.202 32.979 109.32 33.1108 109.407 33.272C109.493 33.4315 109.536 33.6227 109.536 33.8457V36.375H108.55V35.855H108.521C108.46 35.9722 108.38 36.0755 108.279 36.165C108.178 36.2529 108.057 36.3221 107.915 36.3726C107.773 36.4214 107.61 36.4458 107.424 36.4458ZM107.722 35.728C107.875 35.728 108.01 35.6979 108.127 35.6377C108.245 35.5758 108.337 35.4928 108.403 35.3887C108.47 35.2845 108.503 35.1665 108.503 35.0347V34.6367C108.471 34.6579 108.426 34.6774 108.369 34.6953C108.314 34.7116 108.251 34.7271 108.181 34.7417C108.111 34.7547 108.041 34.7669 107.971 34.7783C107.901 34.7881 107.838 34.797 107.781 34.8052C107.659 34.8231 107.552 34.8516 107.461 34.8906C107.37 34.9297 107.299 34.9826 107.249 35.0493C107.198 35.1144 107.173 35.1958 107.173 35.2935C107.173 35.4351 107.224 35.5433 107.327 35.6182C107.431 35.6914 107.563 35.728 107.722 35.728ZM110.343 36.375V32.625H111.351V33.2793H111.39C111.459 33.0465 111.573 32.8708 111.735 32.752C111.896 32.6315 112.081 32.5713 112.291 32.5713C112.343 32.5713 112.399 32.5745 112.46 32.5811C112.52 32.5876 112.573 32.5965 112.618 32.6079V33.5308C112.57 33.5161 112.502 33.5031 112.416 33.4917C112.33 33.4803 112.251 33.4746 112.179 33.4746C112.026 33.4746 111.889 33.508 111.769 33.5747C111.65 33.6398 111.556 33.731 111.486 33.8481C111.417 33.9653 111.383 34.1004 111.383 34.2534V36.375H110.343ZM114.363 36.436C114.079 36.436 113.821 36.3628 113.589 36.2163C113.36 36.0682 113.178 35.8509 113.043 35.5645C112.909 35.2764 112.842 34.9232 112.842 34.5049C112.842 34.0752 112.912 33.7179 113.05 33.4331C113.188 33.1466 113.372 32.9326 113.602 32.791C113.833 32.6478 114.086 32.5762 114.361 32.5762C114.571 32.5762 114.746 32.612 114.886 32.6836C115.027 32.7536 115.141 32.8415 115.228 32.9473C115.316 33.0514 115.382 33.154 115.428 33.2549H115.46V31.375H116.497V36.375H115.472V35.7744H115.428C115.379 35.8786 115.31 35.9819 115.22 36.0845C115.132 36.1854 115.018 36.2692 114.876 36.3359C114.736 36.4027 114.565 36.436 114.363 36.436ZM114.693 35.6084C114.861 35.6084 115.002 35.5628 115.118 35.4717C115.235 35.3789 115.325 35.2495 115.386 35.0835C115.45 34.9175 115.482 34.723 115.482 34.5C115.482 34.277 115.451 34.0833 115.389 33.9189C115.327 33.7546 115.237 33.6276 115.12 33.5381C115.003 33.4486 114.861 33.4038 114.693 33.4038C114.522 33.4038 114.378 33.4502 114.261 33.543C114.144 33.6357 114.055 33.7643 113.995 33.9287C113.935 34.0931 113.904 34.2835 113.904 34.5C113.904 34.7181 113.935 34.911 113.995 35.0786C114.057 35.2446 114.145 35.3748 114.261 35.4692C114.378 35.562 114.522 35.6084 114.693 35.6084Z"
						fill="#181D27"
					/>
					<rect
						fill="#F5F5F5"
						height="6.875"
						rx="1.875"
						width="20"
						x="138.125"
						y="29.375"
					/>
					<rect
						fill="#7F56D9"
						height="6.875"
						rx="1.875"
						width="20"
						x="161.25"
						y="29.375"
					/>
					<mask fill="white" id="path-22-inside-2_4931_10045">
						<path d="M12.5 23.125H57.5V142.5H12.5V23.125Z" />
					</mask>
					<path
						d="M57.1875 23.125V142.5H57.8125V23.125H57.1875Z"
						fill="#E9EAEB"
						mask="url(#path-22-inside-2_4931_10045)"
					/>
					<rect
						fill="#7F56D9"
						height="3.75"
						rx="1.25"
						width="13.75"
						x="25.625"
						y="30"
					/>
					<rect
						fill="#7F56D9"
						height="5"
						rx="2.5"
						width="5"
						x="18.75"
						y="29.375"
					/>
					<rect
						fill="#7F56D9"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="41.875"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="50.625"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="59.375"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="68.125"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="76.875"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="85.625"
					/>
				</g>
				<rect
					height="129.375"
					rx="4.6875"
					stroke="#D5D7DA"
					strokeWidth="0.625"
					width="174.375"
					x="12.8125"
					y="12.8125"
				/>
			</g>
			<path
				d="M10 0.5H190C195.247 0.5 199.5 4.7533 199.5 10V122C199.5 127.247 195.247 131.5 190 131.5H10C4.7533 131.5 0.5 127.247 0.5 122V10C0.5 4.75329 4.75329 0.5 10 0.5Z"
				stroke="#D5D7DA"
			/>
			<g clipPath="url(#clip3_4931_10045)">
				<mask fill="white" id="path-32-inside-3_4931_10045">
					<path d="M100 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H100V0Z" />
				</mask>
				<path
					d="M100 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H100V0Z"
					fill="#22262F"
				/>
				<rect
					fill="#373A41"
					height="1.25"
					transform="translate(0 13.125)"
					width="200"
				/>
				<rect
					fill="#373A41"
					height="1.25001"
					transform="translate(185.625 117.5) rotate(-90)"
					width="117.5"
				/>
				<g clipPath="url(#clip4_4931_10045)">
					<rect
						fill="#0C0E12"
						height="130"
						rx="5"
						width="175"
						x="12.5"
						y="12.5"
					/>
					<mask fill="white" id="path-36-inside-4_4931_10045">
						<path d="M12.5 17.5C12.5 14.7386 14.7386 12.5 17.5 12.5H182.5C185.261 12.5 187.5 14.7386 187.5 17.5V23.125H12.5V17.5Z" />
					</mask>
					<path
						d="M12.5 17.5C12.5 14.7386 14.7386 12.5 17.5 12.5H182.5C185.261 12.5 187.5 14.7386 187.5 17.5V23.125H12.5V17.5Z"
						fill="#13161B"
					/>
					<path
						d="M12.5 12.5H187.5H12.5ZM187.5 23.75H12.5V22.5H187.5V23.75ZM12.5 23.125V12.5V23.125ZM187.5 12.5V23.125V12.5Z"
						fill="#373A41"
						mask="url(#path-36-inside-4_4931_10045)"
					/>
					<rect
						fill="#13161B"
						height="45"
						rx="3.75"
						width="117.5"
						x="63.75"
						y="50.3125"
					/>
					<mask
						height="34"
						id="mask1_4931_10045"
						maskUnits="userSpaceOnUse"
						style={{ maskType: "alpha" }}
						width="105"
						x="70"
						y="57"
					>
						<rect
							fill="url(#paint1_linear_4931_10045)"
							height="32.5"
							transform="translate(70 57.8125)"
							width="105"
						/>
					</mask>
					<g mask="url(#mask1_4931_10045)">
						<path
							d="M92.4617 80.1255L81.2734 83.5912C81.253 83.5975 81.2321 83.6017 81.211 83.6037L70.2824 84.6602C70.1222 84.6757 70 84.8103 70 84.9712V87.1875C70 87.3601 70.1399 87.5 70.3125 87.5H174.688C174.86 87.5 175 87.3601 175 87.1875V62.983C175 62.8104 174.86 62.6705 174.688 62.6705H171.303C171.268 62.6705 171.233 62.6646 171.2 62.653L160.128 58.7945C160.046 58.7661 159.957 58.7727 159.88 58.8127L148.793 64.6081C148.765 64.6231 148.734 64.6335 148.702 64.639L137.541 66.5838C137.514 66.5885 137.487 66.5968 137.463 66.6083L126.339 71.7769C126.281 71.8038 126.216 71.8123 126.153 71.8014L115.071 69.8704C115.024 69.8622 114.976 69.8649 114.931 69.8781L103.791 73.113C103.764 73.121 103.738 73.1326 103.714 73.1477L92.5341 80.0925C92.5115 80.1065 92.4871 80.1176 92.4617 80.1255Z"
							fill="#9E77ED"
							opacity="0.1"
						/>
					</g>
					<path
						d="M70 84.6875L81.211 83.6037C81.2321 83.6017 81.253 83.5974 81.2734 83.5912L92.4617 80.1255C92.4871 80.1176 92.5115 80.1065 92.5341 80.0925L103.714 73.1477C103.738 73.1326 103.764 73.121 103.791 73.113L114.931 69.8781C114.976 69.8649 115.024 69.8622 115.071 69.8704L126.154 71.8014C126.216 71.8123 126.281 71.8038 126.339 71.7769L137.463 66.6083C137.487 66.5968 137.514 66.5885 137.541 66.5838L148.702 64.639C148.734 64.6335 148.765 64.6231 148.793 64.6081L159.88 58.8127C159.957 58.7727 160.046 58.7661 160.128 58.7945L171.2 62.653C171.233 62.6646 171.268 62.6705 171.303 62.6705H175"
						stroke="#9E77ED"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="0.625"
					/>
					<path
						d="M63.75 104.062C63.75 101.991 65.4289 100.312 67.5 100.312H177.5C179.571 100.312 181.25 101.991 181.25 104.063V141.563C181.25 143.634 179.571 145.312 177.5 145.312H67.5C65.4289 145.312 63.75 143.634 63.75 141.562V104.062Z"
						fill="#13161B"
					/>
					<rect
						fill="#22262F"
						height="3.75"
						rx="1.25"
						width="65"
						x="63.75"
						y="41.5625"
					/>
					<path
						d="M63.8916 31.375H65.0757L66.2158 33.5283H66.2646L67.4048 31.375H68.5889L66.7651 34.6074V36.375H65.7153V34.6074L63.8916 31.375ZM70.0555 36.4482C69.6763 36.4482 69.3483 36.3677 69.0717 36.2065C68.7966 36.0438 68.5842 35.8175 68.4344 35.5278C68.2847 35.2365 68.2098 34.8988 68.2098 34.5146C68.2098 34.1273 68.2847 33.7887 68.4344 33.499C68.5842 33.2077 68.7966 32.9814 69.0717 32.8203C69.3483 32.6576 69.6763 32.5762 70.0555 32.5762C70.4348 32.5762 70.7619 32.6576 71.037 32.8203C71.3137 32.9814 71.5269 33.2077 71.6766 33.499C71.8264 33.7887 71.9012 34.1273 71.9012 34.5146C71.9012 34.8988 71.8264 35.2365 71.6766 35.5278C71.5269 35.8175 71.3137 36.0438 71.037 36.2065C70.7619 36.3677 70.4348 36.4482 70.0555 36.4482ZM70.0604 35.6426C70.233 35.6426 70.377 35.5937 70.4926 35.4961C70.6081 35.3968 70.6952 35.2617 70.7538 35.0908C70.814 34.9199 70.8441 34.7254 70.8441 34.5073C70.8441 34.2892 70.814 34.0947 70.7538 33.9238C70.6952 33.7529 70.6081 33.6178 70.4926 33.5186C70.377 33.4193 70.233 33.3696 70.0604 33.3696C69.8863 33.3696 69.7398 33.4193 69.621 33.5186C69.5038 33.6178 69.4151 33.7529 69.3549 33.9238C69.2963 34.0947 69.267 34.2892 69.267 34.5073C69.267 34.7254 69.2963 34.9199 69.3549 35.0908C69.4151 35.2617 69.5038 35.3968 69.621 35.4961C69.7398 35.5937 69.8863 35.6426 70.0604 35.6426ZM74.9823 34.7783V32.625H76.0223V36.375H75.0238V35.6938H74.9847C74.9001 35.9136 74.7593 36.0902 74.5624 36.2236C74.3671 36.3571 74.1286 36.4238 73.847 36.4238C73.5964 36.4238 73.3759 36.3669 73.1854 36.2529C72.995 36.139 72.8461 35.9771 72.7386 35.7671C72.6329 35.5571 72.5791 35.3057 72.5775 35.0127V32.625H73.6176V34.8271C73.6192 35.0485 73.6786 35.2235 73.7958 35.3521C73.913 35.4806 74.07 35.5449 74.267 35.5449C74.3923 35.5449 74.5095 35.5164 74.6185 35.4595C74.7276 35.4009 74.8155 35.3146 74.8822 35.2007C74.9506 35.0868 74.9839 34.946 74.9823 34.7783ZM76.8542 36.375V32.625H77.8625V33.2793H77.9016C77.97 33.0465 78.0847 32.8708 78.2458 32.752C78.407 32.6315 78.5925 32.5713 78.8025 32.5713C78.8546 32.5713 78.9107 32.5745 78.9709 32.5811C79.0312 32.5876 79.0841 32.5965 79.1296 32.6079V33.5308C79.0808 33.5161 79.0133 33.5031 78.927 33.4917C78.8407 33.4803 78.7618 33.4746 78.6902 33.4746C78.5372 33.4746 78.4005 33.508 78.28 33.5747C78.1612 33.6398 78.0668 33.731 77.9968 33.8481C77.9285 33.9653 77.8943 34.1004 77.8943 34.2534V36.375H76.8542ZM82.6404 36.436C82.3556 36.436 82.0976 36.3628 81.8665 36.2163C81.637 36.0682 81.4547 35.8509 81.3196 35.5645C81.1861 35.2764 81.1194 34.9232 81.1194 34.5049C81.1194 34.0752 81.1886 33.7179 81.3269 33.4331C81.4653 33.1466 81.6492 32.9326 81.8787 32.791C82.1098 32.6478 82.3629 32.5762 82.6379 32.5762C82.8479 32.5762 83.0229 32.612 83.1628 32.6836C83.3044 32.7536 83.4184 32.8415 83.5046 32.9473C83.5925 33.0514 83.6593 33.154 83.7048 33.2549H83.7366V31.375H84.7742V36.375H83.7488V35.7744H83.7048C83.656 35.8786 83.5868 35.9819 83.4973 36.0845C83.4094 36.1854 83.2947 36.2692 83.1531 36.3359C83.0131 36.4027 82.8422 36.436 82.6404 36.436ZM82.97 35.6084C83.1376 35.6084 83.2792 35.5628 83.3948 35.4717C83.512 35.3789 83.6015 35.2495 83.6633 35.0835C83.7268 34.9175 83.7585 34.723 83.7585 34.5C83.7585 34.277 83.7276 34.0833 83.6658 33.9189C83.6039 33.7546 83.5144 33.6276 83.3972 33.5381C83.28 33.4486 83.1376 33.4038 82.97 33.4038C82.7991 33.4038 82.655 33.4502 82.5378 33.543C82.4207 33.6357 82.3319 33.7643 82.2717 33.9287C82.2115 34.0931 82.1814 34.2835 82.1814 34.5C82.1814 34.7181 82.2115 34.911 82.2717 35.0786C82.3336 35.2446 82.4223 35.3748 82.5378 35.4692C82.655 35.562 82.7991 35.6084 82.97 35.6084ZM86.6986 36.4458C86.4594 36.4458 86.2461 36.4043 86.059 36.3213C85.8718 36.2367 85.7237 36.1121 85.6146 35.9478C85.5072 35.7817 85.4535 35.575 85.4535 35.3276C85.4535 35.1193 85.4917 34.9443 85.5682 34.8027C85.6447 34.6611 85.7489 34.5472 85.8807 34.4609C86.0126 34.3747 86.1623 34.3096 86.33 34.2656C86.4992 34.2217 86.6766 34.1908 86.8622 34.1729C87.0803 34.1501 87.2561 34.1289 87.3895 34.1094C87.523 34.0882 87.6198 34.0573 87.6801 34.0166C87.7403 33.9759 87.7704 33.9157 87.7704 33.8359V33.8213C87.7704 33.6667 87.7216 33.547 87.6239 33.4624C87.5279 33.3778 87.3912 33.3354 87.2137 33.3354C87.0266 33.3354 86.8776 33.377 86.767 33.46C86.6563 33.5413 86.583 33.6439 86.5472 33.7676L85.5853 33.6895C85.6342 33.4616 85.7302 33.2646 85.8734 33.0986C86.0166 32.931 86.2014 32.8024 86.4276 32.7129C86.6555 32.6217 86.9191 32.5762 87.2186 32.5762C87.427 32.5762 87.6263 32.6006 87.8168 32.6494C88.0088 32.6982 88.1789 32.7739 88.327 32.8765C88.4768 32.979 88.5948 33.1108 88.681 33.272C88.7673 33.4315 88.8104 33.6227 88.8104 33.8457V36.375H87.8241V35.855H87.7948C87.7346 35.9722 87.654 36.0755 87.5531 36.165C87.4522 36.2529 87.3309 36.3221 87.1893 36.3726C87.0477 36.4214 86.8842 36.4458 86.6986 36.4458ZM86.9965 35.728C87.1495 35.728 87.2845 35.6979 87.4017 35.6377C87.5189 35.5758 87.6109 35.4928 87.6776 35.3887C87.7443 35.2845 87.7777 35.1665 87.7777 35.0347V34.6367C87.7452 34.6579 87.7004 34.6774 87.6434 34.6953C87.5881 34.7116 87.5254 34.7271 87.4554 34.7417C87.3855 34.7547 87.3155 34.7669 87.2455 34.7783C87.1755 34.7881 87.112 34.797 87.0551 34.8052C86.933 34.8231 86.8264 34.8516 86.7352 34.8906C86.6441 34.9297 86.5733 34.9826 86.5228 35.0493C86.4724 35.1144 86.4471 35.1958 86.4471 35.2935C86.4471 35.4351 86.4984 35.5433 86.601 35.6182C86.7051 35.6914 86.837 35.728 86.9965 35.728ZM92.7374 33.6943L91.7853 33.7529C91.769 33.6715 91.734 33.5983 91.6803 33.5332C91.6266 33.4665 91.5558 33.4136 91.4679 33.3745C91.3816 33.3338 91.2783 33.3135 91.1578 33.3135C90.9967 33.3135 90.8608 33.3477 90.7501 33.416C90.6394 33.4827 90.5841 33.5723 90.5841 33.6846C90.5841 33.7741 90.6199 33.8498 90.6915 33.9116C90.7631 33.9735 90.886 34.0231 91.0602 34.0605L91.7389 34.1973C92.1035 34.2721 92.3753 34.3926 92.5543 34.5586C92.7334 34.7246 92.8229 34.9427 92.8229 35.2129C92.8229 35.4587 92.7504 35.6743 92.6056 35.8599C92.4624 36.0454 92.2654 36.1903 92.0148 36.2944C91.7657 36.397 91.4785 36.4482 91.153 36.4482C90.6565 36.4482 90.261 36.3449 89.9664 36.1382C89.6735 35.9299 89.5017 35.6466 89.4513 35.2886L90.4742 35.2349C90.5052 35.3862 90.58 35.5018 90.6989 35.5815C90.8177 35.6597 90.9698 35.6987 91.1554 35.6987C91.3377 35.6987 91.4842 35.6637 91.5948 35.5937C91.7072 35.5221 91.7641 35.4302 91.7657 35.3179C91.7641 35.2235 91.7242 35.1462 91.6461 35.0859C91.568 35.0241 91.4476 34.9769 91.2848 34.9443L90.6354 34.8149C90.2692 34.7417 89.9965 34.6147 89.8175 34.4341C89.6401 34.2534 89.5514 34.0231 89.5514 33.7432C89.5514 33.5023 89.6165 33.2948 89.7467 33.1206C89.8785 32.9465 90.0633 32.8122 90.3009 32.7178C90.5402 32.6234 90.8201 32.5762 91.1407 32.5762C91.6144 32.5762 91.9871 32.6763 92.2589 32.8765C92.5323 33.0767 92.6919 33.3493 92.7374 33.6943ZM94.5178 34.207V36.375H93.4778V31.375H94.4885V33.2866H94.5325C94.6171 33.0653 94.7538 32.8919 94.9426 32.7666C95.1314 32.6396 95.3682 32.5762 95.6531 32.5762C95.9135 32.5762 96.1405 32.6331 96.3342 32.7471C96.5295 32.8594 96.6809 33.0213 96.7883 33.2329C96.8974 33.4429 96.9511 33.6943 96.9495 33.9873V36.375H95.9094V34.1729C95.9111 33.9417 95.8525 33.7619 95.7336 33.6333C95.6165 33.5047 95.4521 33.4404 95.2405 33.4404C95.0989 33.4404 94.9736 33.4705 94.8645 33.5308C94.7571 33.591 94.6724 33.6789 94.6106 33.7944C94.5504 33.9084 94.5194 34.0459 94.5178 34.207ZM97.7875 36.375V31.375H98.8275V33.2549H98.8593C98.9048 33.154 98.9707 33.0514 99.057 32.9473C99.1449 32.8415 99.2588 32.7536 99.3988 32.6836C99.5404 32.612 99.7162 32.5762 99.9261 32.5762C100.2 32.5762 100.452 32.6478 100.683 32.791C100.914 32.9326 101.099 33.1466 101.237 33.4331C101.376 33.7179 101.445 34.0752 101.445 34.5049C101.445 34.9232 101.377 35.2764 101.242 35.5645C101.109 35.8509 100.926 36.0682 100.695 36.2163C100.466 36.3628 100.209 36.436 99.9237 36.436C99.7219 36.436 99.5502 36.4027 99.4086 36.3359C99.2686 36.2692 99.1538 36.1854 99.0643 36.0845C98.9748 35.9819 98.9065 35.8786 98.8593 35.7744H98.8129V36.375H97.7875ZM98.8055 34.5C98.8055 34.723 98.8365 34.9175 98.8983 35.0835C98.9602 35.2495 99.0497 35.3789 99.1669 35.4717C99.2841 35.5628 99.4265 35.6084 99.5941 35.6084C99.7634 35.6084 99.9066 35.562 100.024 35.4692C100.141 35.3748 100.23 35.2446 100.29 35.0786C100.352 34.911 100.383 34.7181 100.383 34.5C100.383 34.2835 100.353 34.0931 100.292 33.9287C100.232 33.7643 100.143 33.6357 100.026 33.543C99.9091 33.4502 99.765 33.4038 99.5941 33.4038C99.4248 33.4038 99.2816 33.4486 99.1644 33.5381C99.0489 33.6276 98.9602 33.7546 98.8983 33.9189C98.8365 34.0833 98.8055 34.277 98.8055 34.5ZM103.833 36.4482C103.454 36.4482 103.126 36.3677 102.849 36.2065C102.574 36.0438 102.362 35.8175 102.212 35.5278C102.062 35.2365 101.987 34.8988 101.987 34.5146C101.987 34.1273 102.062 33.7887 102.212 33.499C102.362 33.2077 102.574 32.9814 102.849 32.8203C103.126 32.6576 103.454 32.5762 103.833 32.5762C104.212 32.5762 104.539 32.6576 104.814 32.8203C105.091 32.9814 105.304 33.2077 105.454 33.499C105.604 33.7887 105.679 34.1273 105.679 34.5146C105.679 34.8988 105.604 35.2365 105.454 35.5278C105.304 35.8175 105.091 36.0438 104.814 36.2065C104.539 36.3677 104.212 36.4482 103.833 36.4482ZM103.838 35.6426C104.01 35.6426 104.154 35.5937 104.27 35.4961C104.386 35.3968 104.473 35.2617 104.531 35.0908C104.591 34.9199 104.622 34.7254 104.622 34.5073C104.622 34.2892 104.591 34.0947 104.531 33.9238C104.473 33.7529 104.386 33.6178 104.27 33.5186C104.154 33.4193 104.01 33.3696 103.838 33.3696C103.664 33.3696 103.517 33.4193 103.398 33.5186C103.281 33.6178 103.193 33.7529 103.132 33.9238C103.074 34.0947 103.044 34.2892 103.044 34.5073C103.044 34.7254 103.074 34.9199 103.132 35.0908C103.193 35.2617 103.281 35.3968 103.398 35.4961C103.517 35.5937 103.664 35.6426 103.838 35.6426ZM107.424 36.4458C107.185 36.4458 106.972 36.4043 106.785 36.3213C106.597 36.2367 106.449 36.1121 106.34 35.9478C106.233 35.7817 106.179 35.575 106.179 35.3276C106.179 35.1193 106.217 34.9443 106.294 34.8027C106.37 34.6611 106.475 34.5472 106.606 34.4609C106.738 34.3747 106.888 34.3096 107.056 34.2656C107.225 34.2217 107.402 34.1908 107.588 34.1729C107.806 34.1501 107.982 34.1289 108.115 34.1094C108.249 34.0882 108.346 34.0573 108.406 34.0166C108.466 33.9759 108.496 33.9157 108.496 33.8359V33.8213C108.496 33.6667 108.447 33.547 108.35 33.4624C108.254 33.3778 108.117 33.3354 107.939 33.3354C107.752 33.3354 107.603 33.377 107.493 33.46C107.382 33.5413 107.309 33.6439 107.273 33.7676L106.311 33.6895C106.36 33.4616 106.456 33.2646 106.599 33.0986C106.742 32.931 106.927 32.8024 107.153 32.7129C107.381 32.6217 107.645 32.5762 107.944 32.5762C108.153 32.5762 108.352 32.6006 108.542 32.6494C108.735 32.6982 108.905 32.7739 109.053 32.8765C109.202 32.979 109.32 33.1108 109.407 33.272C109.493 33.4315 109.536 33.6227 109.536 33.8457V36.375H108.55V35.855H108.521C108.46 35.9722 108.38 36.0755 108.279 36.165C108.178 36.2529 108.057 36.3221 107.915 36.3726C107.773 36.4214 107.61 36.4458 107.424 36.4458ZM107.722 35.728C107.875 35.728 108.01 35.6979 108.127 35.6377C108.245 35.5758 108.337 35.4928 108.403 35.3887C108.47 35.2845 108.503 35.1665 108.503 35.0347V34.6367C108.471 34.6579 108.426 34.6774 108.369 34.6953C108.314 34.7116 108.251 34.7271 108.181 34.7417C108.111 34.7547 108.041 34.7669 107.971 34.7783C107.901 34.7881 107.838 34.797 107.781 34.8052C107.659 34.8231 107.552 34.8516 107.461 34.8906C107.37 34.9297 107.299 34.9826 107.249 35.0493C107.198 35.1144 107.173 35.1958 107.173 35.2935C107.173 35.4351 107.224 35.5433 107.327 35.6182C107.431 35.6914 107.563 35.728 107.722 35.728ZM110.343 36.375V32.625H111.351V33.2793H111.39C111.459 33.0465 111.573 32.8708 111.735 32.752C111.896 32.6315 112.081 32.5713 112.291 32.5713C112.343 32.5713 112.399 32.5745 112.46 32.5811C112.52 32.5876 112.573 32.5965 112.618 32.6079V33.5308C112.57 33.5161 112.502 33.5031 112.416 33.4917C112.33 33.4803 112.251 33.4746 112.179 33.4746C112.026 33.4746 111.889 33.508 111.769 33.5747C111.65 33.6398 111.556 33.731 111.486 33.8481C111.417 33.9653 111.383 34.1004 111.383 34.2534V36.375H110.343ZM114.363 36.436C114.079 36.436 113.821 36.3628 113.589 36.2163C113.36 36.0682 113.178 35.8509 113.043 35.5645C112.909 35.2764 112.842 34.9232 112.842 34.5049C112.842 34.0752 112.912 33.7179 113.05 33.4331C113.188 33.1466 113.372 32.9326 113.602 32.791C113.833 32.6478 114.086 32.5762 114.361 32.5762C114.571 32.5762 114.746 32.612 114.886 32.6836C115.027 32.7536 115.141 32.8415 115.228 32.9473C115.316 33.0514 115.382 33.154 115.428 33.2549H115.46V31.375H116.497V36.375H115.472V35.7744H115.428C115.379 35.8786 115.31 35.9819 115.22 36.0845C115.132 36.1854 115.018 36.2692 114.876 36.3359C114.736 36.4027 114.565 36.436 114.363 36.436ZM114.693 35.6084C114.861 35.6084 115.002 35.5628 115.118 35.4717C115.235 35.3789 115.325 35.2495 115.386 35.0835C115.45 34.9175 115.482 34.723 115.482 34.5C115.482 34.277 115.451 34.0833 115.389 33.9189C115.327 33.7546 115.237 33.6276 115.12 33.5381C115.003 33.4486 114.861 33.4038 114.693 33.4038C114.522 33.4038 114.378 33.4502 114.261 33.543C114.144 33.6357 114.055 33.7643 113.995 33.9287C113.935 34.0931 113.904 34.2835 113.904 34.5C113.904 34.7181 113.935 34.911 113.995 35.0786C114.057 35.2446 114.145 35.3748 114.261 35.4692C114.378 35.562 114.522 35.6084 114.693 35.6084Z"
						fill="#F7F7F7"
					/>
					<rect
						fill="#22262F"
						height="6.875"
						rx="1.875"
						width="20"
						x="138.125"
						y="29.375"
					/>
					<rect
						fill="#7F56D9"
						height="6.875"
						rx="1.875"
						width="20"
						x="161.25"
						y="29.375"
					/>
				</g>
				<rect
					height="129.375"
					rx="4.6875"
					stroke="#373A41"
					strokeWidth="0.625"
					width="174.375"
					x="12.8125"
					y="12.8125"
				/>
			</g>
			<path
				d="M100 -1H190C196.075 -1 201 3.92487 201 10H199C199 5.02944 194.971 1 190 1H100V-1ZM201 122C201 128.075 196.075 133 190 133H100V131H190C194.971 131 199 126.971 199 122H201ZM100 132V0V132ZM190 -1C196.075 -1 201 3.92487 201 10V122C201 128.075 196.075 133 190 133V131C194.971 131 199 126.971 199 122V10C199 5.02944 194.971 1 190 1V-1Z"
				fill="#373A41"
				mask="url(#path-32-inside-3_4931_10045)"
			/>
		</g>
		<defs>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter0_i_4931_10045"
				width="3.75"
				x="16.875"
				y="16.25"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_4931_10045"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter1_i_4931_10045"
				width="3.75"
				x="23.125"
				y="16.25"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_4931_10045"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter2_i_4931_10045"
				width="3.75"
				x="29.375"
				y="16.25"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_4931_10045"
				/>
			</filter>
			<linearGradient
				gradientUnits="userSpaceOnUse"
				id="paint0_linear_4931_10045"
				x1="52.5"
				x2="52.5"
				y1="0"
				y2="32.5"
			>
				<stop />
				<stop offset="1" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				gradientUnits="userSpaceOnUse"
				id="paint1_linear_4931_10045"
				x1="52.5"
				x2="52.5"
				y1="0"
				y2="32.5"
			>
				<stop />
				<stop offset="1" stopOpacity="0" />
			</linearGradient>
			<clipPath id="clip0_4931_10045">
				<path
					d="M0 10C0 4.47715 4.47715 0 10 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H10C4.47716 132 0 127.523 0 122V10Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_4931_10045">
				<path
					d="M0 10C0 4.47715 4.47715 0 10 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H10C4.47716 132 0 127.523 0 122V10Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_4931_10045">
				<rect fill="white" height="130" rx="5" width="175" x="12.5" y="12.5" />
			</clipPath>
			<clipPath id="clip3_4931_10045">
				<path
					d="M100 0H190C195.523 0 200 4.47715 200 10V122C200 127.523 195.523 132 190 132H100V0Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip4_4931_10045">
				<rect fill="white" height="130" rx="5" width="175" x="12.5" y="12.5" />
			</clipPath>
		</defs>
	</svg>
);

export const Light = (props: SVGProps<SVGSVGElement>) => (
	<svg
		className="h-full w-full"
		fill="none"
		viewBox="0 0 200 133"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_8021_27248)">
			<path
				d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
				fill="#F5F5F5"
			/>
			<g clipPath="url(#clip1_8021_27248)">
				<rect
					fill="#E9EAEB"
					height="1.25001"
					transform="translate(13.125 118) rotate(-90)"
					width="117.5"
				/>
				<rect
					fill="#E9EAEB"
					height="1.25"
					transform="translate(0 13.625)"
					width="200"
				/>
				<rect
					fill="#E9EAEB"
					height="1.25001"
					transform="translate(185.625 118) rotate(-90)"
					width="117.5"
				/>
				<g clipPath="url(#clip2_8021_27248)">
					<rect fill="white" height="130" rx="5" width="175" x="12.5" y="13" />
					<mask fill="white" id="path-6-inside-1_8021_27248">
						<path d="M12.5 18C12.5 15.2386 14.7386 13 17.5 13H182.5C185.261 13 187.5 15.2386 187.5 18V23.625H12.5V18Z" />
					</mask>
					<path
						d="M12.5 18C12.5 15.2386 14.7386 13 17.5 13H182.5C185.261 13 187.5 15.2386 187.5 18V23.625H12.5V18Z"
						fill="#FAFAFA"
					/>
					<path
						d="M12.5 13H187.5H12.5ZM187.5 24.25H12.5V23H187.5V24.25ZM12.5 23.625V13V23.625ZM187.5 13V23.625V13Z"
						fill="#E9EAEB"
						mask="url(#path-6-inside-1_8021_27248)"
					/>
					<g filter="url(#filter0_i_8021_27248)">
						<circle cx="18.75" cy="18.625" fill="#EE6A5F" r="1.875" />
					</g>
					<circle
						cx="18.75"
						cy="18.625"
						r="1.79688"
						stroke="#CE5347"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter1_i_8021_27248)">
						<circle cx="25" cy="18.625" fill="#F5BD4F" r="1.875" />
					</g>
					<circle
						cx="25"
						cy="18.625"
						r="1.79688"
						stroke="#D6A243"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter2_i_8021_27248)">
						<circle cx="31.25" cy="18.625" fill="#61C454" r="1.875" />
					</g>
					<circle
						cx="31.25"
						cy="18.625"
						r="1.79688"
						stroke="#58A942"
						strokeWidth="0.15625"
					/>
					<rect
						fill="#FAFAFA"
						height="45"
						rx="3.75"
						width="117.5"
						x="63.75"
						y="50.8125"
					/>
					<mask
						height="33"
						id="mask0_8021_27248"
						maskUnits="userSpaceOnUse"
						style={{ maskType: "alpha" }}
						width="105"
						x="70"
						y="58"
					>
						<rect
							fill="url(#paint0_linear_8021_27248)"
							height="32.5"
							transform="translate(70 58.3125)"
							width="105"
						/>
					</mask>
					<g mask="url(#mask0_8021_27248)">
						<path
							d="M92.4617 80.6255L81.2734 84.0912C81.253 84.0975 81.2321 84.1017 81.211 84.1037L70.2824 85.1602C70.1222 85.1757 70 85.3103 70 85.4712V87.6875C70 87.8601 70.1399 88 70.3125 88H174.688C174.86 88 175 87.8601 175 87.6875V63.483C175 63.3104 174.86 63.1705 174.688 63.1705H171.303C171.268 63.1705 171.233 63.1646 171.2 63.153L160.128 59.2945C160.046 59.2661 159.957 59.2727 159.88 59.3127L148.793 65.1081C148.765 65.1231 148.734 65.1335 148.702 65.139L137.541 67.0838C137.514 67.0885 137.487 67.0968 137.463 67.1083L126.339 72.2769C126.281 72.3038 126.216 72.3123 126.153 72.3014L115.071 70.3704C115.024 70.3622 114.976 70.3649 114.931 70.3781L103.791 73.613C103.764 73.621 103.738 73.6326 103.714 73.6477L92.5341 80.5925C92.5115 80.6065 92.4871 80.6176 92.4617 80.6255Z"
							fill="#7F56D9"
							opacity="0.1"
						/>
					</g>
					<path
						d="M70 85.1875L81.211 84.1037C81.2321 84.1017 81.253 84.0974 81.2734 84.0912L92.4617 80.6255C92.4871 80.6176 92.5115 80.6065 92.5341 80.5925L103.714 73.6477C103.738 73.6326 103.764 73.621 103.791 73.613L114.931 70.3781C114.976 70.3649 115.024 70.3622 115.071 70.3704L126.154 72.3014C126.216 72.3123 126.281 72.3038 126.339 72.2769L137.463 67.1083C137.487 67.0968 137.514 67.0885 137.541 67.0838L148.702 65.139C148.734 65.1335 148.765 65.1231 148.793 65.1081L159.88 59.3127C159.957 59.2727 160.046 59.2661 160.128 59.2945L171.2 63.153C171.233 63.1646 171.268 63.1705 171.303 63.1705H175"
						stroke="#7F56D9"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="0.625"
					/>
					<path
						d="M63.75 104.562C63.75 102.491 65.4289 100.812 67.5 100.812H177.5C179.571 100.812 181.25 102.491 181.25 104.562V142.062C181.25 144.134 179.571 145.812 177.5 145.812H67.5C65.4289 145.812 63.75 144.134 63.75 142.062V104.562Z"
						fill="#FAFAFA"
					/>
					<rect
						fill="#F5F5F5"
						height="3.75"
						rx="1.25"
						width="65"
						x="63.75"
						y="42.0625"
					/>
					<path
						d="M63.8916 31.875H65.0757L66.2158 34.0283H66.2646L67.4048 31.875H68.5889L66.7651 35.1074V36.875H65.7153V35.1074L63.8916 31.875ZM70.0555 36.9482C69.6763 36.9482 69.3483 36.8677 69.0717 36.7065C68.7966 36.5438 68.5842 36.3175 68.4344 36.0278C68.2847 35.7365 68.2098 35.3988 68.2098 35.0146C68.2098 34.6273 68.2847 34.2887 68.4344 33.999C68.5842 33.7077 68.7966 33.4814 69.0717 33.3203C69.3483 33.1576 69.6763 33.0762 70.0555 33.0762C70.4348 33.0762 70.7619 33.1576 71.037 33.3203C71.3137 33.4814 71.5269 33.7077 71.6766 33.999C71.8264 34.2887 71.9012 34.6273 71.9012 35.0146C71.9012 35.3988 71.8264 35.7365 71.6766 36.0278C71.5269 36.3175 71.3137 36.5438 71.037 36.7065C70.7619 36.8677 70.4348 36.9482 70.0555 36.9482ZM70.0604 36.1426C70.233 36.1426 70.377 36.0937 70.4926 35.9961C70.6081 35.8968 70.6952 35.7617 70.7538 35.5908C70.814 35.4199 70.8441 35.2254 70.8441 35.0073C70.8441 34.7892 70.814 34.5947 70.7538 34.4238C70.6952 34.2529 70.6081 34.1178 70.4926 34.0186C70.377 33.9193 70.233 33.8696 70.0604 33.8696C69.8863 33.8696 69.7398 33.9193 69.621 34.0186C69.5038 34.1178 69.4151 34.2529 69.3549 34.4238C69.2963 34.5947 69.267 34.7892 69.267 35.0073C69.267 35.2254 69.2963 35.4199 69.3549 35.5908C69.4151 35.7617 69.5038 35.8968 69.621 35.9961C69.7398 36.0937 69.8863 36.1426 70.0604 36.1426ZM74.9823 35.2783V33.125H76.0223V36.875H75.0238V36.1938H74.9847C74.9001 36.4136 74.7593 36.5902 74.5624 36.7236C74.3671 36.8571 74.1286 36.9238 73.847 36.9238C73.5964 36.9238 73.3759 36.8669 73.1854 36.7529C72.995 36.639 72.8461 36.4771 72.7386 36.2671C72.6329 36.0571 72.5791 35.8057 72.5775 35.5127V33.125H73.6176V35.3271C73.6192 35.5485 73.6786 35.7235 73.7958 35.8521C73.913 35.9806 74.07 36.0449 74.267 36.0449C74.3923 36.0449 74.5095 36.0164 74.6185 35.9595C74.7276 35.9009 74.8155 35.8146 74.8822 35.7007C74.9506 35.5868 74.9839 35.446 74.9823 35.2783ZM76.8542 36.875V33.125H77.8625V33.7793H77.9016C77.97 33.5465 78.0847 33.3708 78.2458 33.252C78.407 33.1315 78.5925 33.0713 78.8025 33.0713C78.8546 33.0713 78.9107 33.0745 78.9709 33.0811C79.0312 33.0876 79.0841 33.0965 79.1296 33.1079V34.0308C79.0808 34.0161 79.0133 34.0031 78.927 33.9917C78.8407 33.9803 78.7618 33.9746 78.6902 33.9746C78.5372 33.9746 78.4005 34.008 78.28 34.0747C78.1612 34.1398 78.0668 34.231 77.9968 34.3481C77.9285 34.4653 77.8943 34.6004 77.8943 34.7534V36.875H76.8542ZM82.6404 36.936C82.3556 36.936 82.0976 36.8628 81.8665 36.7163C81.637 36.5682 81.4547 36.3509 81.3196 36.0645C81.1861 35.7764 81.1194 35.4232 81.1194 35.0049C81.1194 34.5752 81.1886 34.2179 81.3269 33.9331C81.4653 33.6466 81.6492 33.4326 81.8787 33.291C82.1098 33.1478 82.3629 33.0762 82.6379 33.0762C82.8479 33.0762 83.0229 33.112 83.1628 33.1836C83.3044 33.2536 83.4184 33.3415 83.5046 33.4473C83.5925 33.5514 83.6593 33.654 83.7048 33.7549H83.7366V31.875H84.7742V36.875H83.7488V36.2744H83.7048C83.656 36.3786 83.5868 36.4819 83.4973 36.5845C83.4094 36.6854 83.2947 36.7692 83.1531 36.8359C83.0131 36.9027 82.8422 36.936 82.6404 36.936ZM82.97 36.1084C83.1376 36.1084 83.2792 36.0628 83.3948 35.9717C83.512 35.8789 83.6015 35.7495 83.6633 35.5835C83.7268 35.4175 83.7585 35.223 83.7585 35C83.7585 34.777 83.7276 34.5833 83.6658 34.4189C83.6039 34.2546 83.5144 34.1276 83.3972 34.0381C83.28 33.9486 83.1376 33.9038 82.97 33.9038C82.7991 33.9038 82.655 33.9502 82.5378 34.043C82.4207 34.1357 82.3319 34.2643 82.2717 34.4287C82.2115 34.5931 82.1814 34.7835 82.1814 35C82.1814 35.2181 82.2115 35.411 82.2717 35.5786C82.3336 35.7446 82.4223 35.8748 82.5378 35.9692C82.655 36.062 82.7991 36.1084 82.97 36.1084ZM86.6986 36.9458C86.4594 36.9458 86.2461 36.9043 86.059 36.8213C85.8718 36.7367 85.7237 36.6121 85.6146 36.4478C85.5072 36.2817 85.4535 36.075 85.4535 35.8276C85.4535 35.6193 85.4917 35.4443 85.5682 35.3027C85.6447 35.1611 85.7489 35.0472 85.8807 34.9609C86.0126 34.8747 86.1623 34.8096 86.33 34.7656C86.4992 34.7217 86.6766 34.6908 86.8622 34.6729C87.0803 34.6501 87.2561 34.6289 87.3895 34.6094C87.523 34.5882 87.6198 34.5573 87.6801 34.5166C87.7403 34.4759 87.7704 34.4157 87.7704 34.3359V34.3213C87.7704 34.1667 87.7216 34.047 87.6239 33.9624C87.5279 33.8778 87.3912 33.8354 87.2137 33.8354C87.0266 33.8354 86.8776 33.877 86.767 33.96C86.6563 34.0413 86.583 34.1439 86.5472 34.2676L85.5853 34.1895C85.6342 33.9616 85.7302 33.7646 85.8734 33.5986C86.0166 33.431 86.2014 33.3024 86.4276 33.2129C86.6555 33.1217 86.9191 33.0762 87.2186 33.0762C87.427 33.0762 87.6263 33.1006 87.8168 33.1494C88.0088 33.1982 88.1789 33.2739 88.327 33.3765C88.4768 33.479 88.5948 33.6108 88.681 33.772C88.7673 33.9315 88.8104 34.1227 88.8104 34.3457V36.875H87.8241V36.355H87.7948C87.7346 36.4722 87.654 36.5755 87.5531 36.665C87.4522 36.7529 87.3309 36.8221 87.1893 36.8726C87.0477 36.9214 86.8842 36.9458 86.6986 36.9458ZM86.9965 36.228C87.1495 36.228 87.2845 36.1979 87.4017 36.1377C87.5189 36.0758 87.6109 35.9928 87.6776 35.8887C87.7443 35.7845 87.7777 35.6665 87.7777 35.5347V35.1367C87.7452 35.1579 87.7004 35.1774 87.6434 35.1953C87.5881 35.2116 87.5254 35.2271 87.4554 35.2417C87.3855 35.2547 87.3155 35.2669 87.2455 35.2783C87.1755 35.2881 87.112 35.297 87.0551 35.3052C86.933 35.3231 86.8264 35.3516 86.7352 35.3906C86.6441 35.4297 86.5733 35.4826 86.5228 35.5493C86.4724 35.6144 86.4471 35.6958 86.4471 35.7935C86.4471 35.9351 86.4984 36.0433 86.601 36.1182C86.7051 36.1914 86.837 36.228 86.9965 36.228ZM92.7374 34.1943L91.7853 34.2529C91.769 34.1715 91.734 34.0983 91.6803 34.0332C91.6266 33.9665 91.5558 33.9136 91.4679 33.8745C91.3816 33.8338 91.2783 33.8135 91.1578 33.8135C90.9967 33.8135 90.8608 33.8477 90.7501 33.916C90.6394 33.9827 90.5841 34.0723 90.5841 34.1846C90.5841 34.2741 90.6199 34.3498 90.6915 34.4116C90.7631 34.4735 90.886 34.5231 91.0602 34.5605L91.7389 34.6973C92.1035 34.7721 92.3753 34.8926 92.5543 35.0586C92.7334 35.2246 92.8229 35.4427 92.8229 35.7129C92.8229 35.9587 92.7504 36.1743 92.6056 36.3599C92.4624 36.5454 92.2654 36.6903 92.0148 36.7944C91.7657 36.897 91.4785 36.9482 91.153 36.9482C90.6565 36.9482 90.261 36.8449 89.9664 36.6382C89.6735 36.4299 89.5017 36.1466 89.4513 35.7886L90.4742 35.7349C90.5052 35.8862 90.58 36.0018 90.6989 36.0815C90.8177 36.1597 90.9698 36.1987 91.1554 36.1987C91.3377 36.1987 91.4842 36.1637 91.5948 36.0937C91.7072 36.0221 91.7641 35.9302 91.7657 35.8179C91.7641 35.7235 91.7242 35.6462 91.6461 35.5859C91.568 35.5241 91.4476 35.4769 91.2848 35.4443L90.6354 35.3149C90.2692 35.2417 89.9965 35.1147 89.8175 34.9341C89.6401 34.7534 89.5514 34.5231 89.5514 34.2432C89.5514 34.0023 89.6165 33.7948 89.7467 33.6206C89.8785 33.4465 90.0633 33.3122 90.3009 33.2178C90.5402 33.1234 90.8201 33.0762 91.1407 33.0762C91.6144 33.0762 91.9871 33.1763 92.2589 33.3765C92.5323 33.5767 92.6919 33.8493 92.7374 34.1943ZM94.5178 34.707V36.875H93.4778V31.875H94.4885V33.7866H94.5325C94.6171 33.5653 94.7538 33.3919 94.9426 33.2666C95.1314 33.1396 95.3682 33.0762 95.6531 33.0762C95.9135 33.0762 96.1405 33.1331 96.3342 33.2471C96.5295 33.3594 96.6809 33.5213 96.7883 33.7329C96.8974 33.9429 96.9511 34.1943 96.9495 34.4873V36.875H95.9094V34.6729C95.9111 34.4417 95.8525 34.2619 95.7336 34.1333C95.6165 34.0047 95.4521 33.9404 95.2405 33.9404C95.0989 33.9404 94.9736 33.9705 94.8645 34.0308C94.7571 34.091 94.6724 34.1789 94.6106 34.2944C94.5504 34.4084 94.5194 34.5459 94.5178 34.707ZM97.7875 36.875V31.875H98.8275V33.7549H98.8593C98.9048 33.654 98.9707 33.5514 99.057 33.4473C99.1449 33.3415 99.2588 33.2536 99.3988 33.1836C99.5404 33.112 99.7162 33.0762 99.9261 33.0762C100.2 33.0762 100.452 33.1478 100.683 33.291C100.914 33.4326 101.099 33.6466 101.237 33.9331C101.376 34.2179 101.445 34.5752 101.445 35.0049C101.445 35.4232 101.377 35.7764 101.242 36.0645C101.109 36.3509 100.926 36.5682 100.695 36.7163C100.466 36.8628 100.209 36.936 99.9237 36.936C99.7219 36.936 99.5502 36.9027 99.4086 36.8359C99.2686 36.7692 99.1538 36.6854 99.0643 36.5845C98.9748 36.4819 98.9065 36.3786 98.8593 36.2744H98.8129V36.875H97.7875ZM98.8055 35C98.8055 35.223 98.8365 35.4175 98.8983 35.5835C98.9602 35.7495 99.0497 35.8789 99.1669 35.9717C99.2841 36.0628 99.4265 36.1084 99.5941 36.1084C99.7634 36.1084 99.9066 36.062 100.024 35.9692C100.141 35.8748 100.23 35.7446 100.29 35.5786C100.352 35.411 100.383 35.2181 100.383 35C100.383 34.7835 100.353 34.5931 100.292 34.4287C100.232 34.2643 100.143 34.1357 100.026 34.043C99.9091 33.9502 99.765 33.9038 99.5941 33.9038C99.4248 33.9038 99.2816 33.9486 99.1644 34.0381C99.0489 34.1276 98.9602 34.2546 98.8983 34.4189C98.8365 34.5833 98.8055 34.777 98.8055 35ZM103.833 36.9482C103.454 36.9482 103.126 36.8677 102.849 36.7065C102.574 36.5438 102.362 36.3175 102.212 36.0278C102.062 35.7365 101.987 35.3988 101.987 35.0146C101.987 34.6273 102.062 34.2887 102.212 33.999C102.362 33.7077 102.574 33.4814 102.849 33.3203C103.126 33.1576 103.454 33.0762 103.833 33.0762C104.212 33.0762 104.539 33.1576 104.814 33.3203C105.091 33.4814 105.304 33.7077 105.454 33.999C105.604 34.2887 105.679 34.6273 105.679 35.0146C105.679 35.3988 105.604 35.7365 105.454 36.0278C105.304 36.3175 105.091 36.5438 104.814 36.7065C104.539 36.8677 104.212 36.9482 103.833 36.9482ZM103.838 36.1426C104.01 36.1426 104.154 36.0937 104.27 35.9961C104.386 35.8968 104.473 35.7617 104.531 35.5908C104.591 35.4199 104.622 35.2254 104.622 35.0073C104.622 34.7892 104.591 34.5947 104.531 34.4238C104.473 34.2529 104.386 34.1178 104.27 34.0186C104.154 33.9193 104.01 33.8696 103.838 33.8696C103.664 33.8696 103.517 33.9193 103.398 34.0186C103.281 34.1178 103.193 34.2529 103.132 34.4238C103.074 34.5947 103.044 34.7892 103.044 35.0073C103.044 35.2254 103.074 35.4199 103.132 35.5908C103.193 35.7617 103.281 35.8968 103.398 35.9961C103.517 36.0937 103.664 36.1426 103.838 36.1426ZM107.424 36.9458C107.185 36.9458 106.972 36.9043 106.785 36.8213C106.597 36.7367 106.449 36.6121 106.34 36.4478C106.233 36.2817 106.179 36.075 106.179 35.8276C106.179 35.6193 106.217 35.4443 106.294 35.3027C106.37 35.1611 106.475 35.0472 106.606 34.9609C106.738 34.8747 106.888 34.8096 107.056 34.7656C107.225 34.7217 107.402 34.6908 107.588 34.6729C107.806 34.6501 107.982 34.6289 108.115 34.6094C108.249 34.5882 108.346 34.5573 108.406 34.5166C108.466 34.4759 108.496 34.4157 108.496 34.3359V34.3213C108.496 34.1667 108.447 34.047 108.35 33.9624C108.254 33.8778 108.117 33.8354 107.939 33.8354C107.752 33.8354 107.603 33.877 107.493 33.96C107.382 34.0413 107.309 34.1439 107.273 34.2676L106.311 34.1895C106.36 33.9616 106.456 33.7646 106.599 33.5986C106.742 33.431 106.927 33.3024 107.153 33.2129C107.381 33.1217 107.645 33.0762 107.944 33.0762C108.153 33.0762 108.352 33.1006 108.542 33.1494C108.735 33.1982 108.905 33.2739 109.053 33.3765C109.202 33.479 109.32 33.6108 109.407 33.772C109.493 33.9315 109.536 34.1227 109.536 34.3457V36.875H108.55V36.355H108.521C108.46 36.4722 108.38 36.5755 108.279 36.665C108.178 36.7529 108.057 36.8221 107.915 36.8726C107.773 36.9214 107.61 36.9458 107.424 36.9458ZM107.722 36.228C107.875 36.228 108.01 36.1979 108.127 36.1377C108.245 36.0758 108.337 35.9928 108.403 35.8887C108.47 35.7845 108.503 35.6665 108.503 35.5347V35.1367C108.471 35.1579 108.426 35.1774 108.369 35.1953C108.314 35.2116 108.251 35.2271 108.181 35.2417C108.111 35.2547 108.041 35.2669 107.971 35.2783C107.901 35.2881 107.838 35.297 107.781 35.3052C107.659 35.3231 107.552 35.3516 107.461 35.3906C107.37 35.4297 107.299 35.4826 107.249 35.5493C107.198 35.6144 107.173 35.6958 107.173 35.7935C107.173 35.9351 107.224 36.0433 107.327 36.1182C107.431 36.1914 107.563 36.228 107.722 36.228ZM110.343 36.875V33.125H111.351V33.7793H111.39C111.459 33.5465 111.573 33.3708 111.735 33.252C111.896 33.1315 112.081 33.0713 112.291 33.0713C112.343 33.0713 112.399 33.0745 112.46 33.0811C112.52 33.0876 112.573 33.0965 112.618 33.1079V34.0308C112.57 34.0161 112.502 34.0031 112.416 33.9917C112.33 33.9803 112.251 33.9746 112.179 33.9746C112.026 33.9746 111.889 34.008 111.769 34.0747C111.65 34.1398 111.556 34.231 111.486 34.3481C111.417 34.4653 111.383 34.6004 111.383 34.7534V36.875H110.343ZM114.363 36.936C114.079 36.936 113.821 36.8628 113.589 36.7163C113.36 36.5682 113.178 36.3509 113.043 36.0645C112.909 35.7764 112.842 35.4232 112.842 35.0049C112.842 34.5752 112.912 34.2179 113.05 33.9331C113.188 33.6466 113.372 33.4326 113.602 33.291C113.833 33.1478 114.086 33.0762 114.361 33.0762C114.571 33.0762 114.746 33.112 114.886 33.1836C115.027 33.2536 115.141 33.3415 115.228 33.4473C115.316 33.5514 115.382 33.654 115.428 33.7549H115.46V31.875H116.497V36.875H115.472V36.2744H115.428C115.379 36.3786 115.31 36.4819 115.22 36.5845C115.132 36.6854 115.018 36.7692 114.876 36.8359C114.736 36.9027 114.565 36.936 114.363 36.936ZM114.693 36.1084C114.861 36.1084 115.002 36.0628 115.118 35.9717C115.235 35.8789 115.325 35.7495 115.386 35.5835C115.45 35.4175 115.482 35.223 115.482 35C115.482 34.777 115.451 34.5833 115.389 34.4189C115.327 34.2546 115.237 34.1276 115.12 34.0381C115.003 33.9486 114.861 33.9038 114.693 33.9038C114.522 33.9038 114.378 33.9502 114.261 34.043C114.144 34.1357 114.055 34.2643 113.995 34.4287C113.935 34.5931 113.904 34.7835 113.904 35C113.904 35.2181 113.935 35.411 113.995 35.5786C114.057 35.7446 114.145 35.8748 114.261 35.9692C114.378 36.062 114.522 36.1084 114.693 36.1084Z"
						fill="#181D27"
					/>
					<rect
						fill="#F5F5F5"
						height="6.875"
						rx="1.875"
						width="20"
						x="138.125"
						y="29.875"
					/>
					<rect
						fill="#7F56D9"
						height="6.875"
						rx="1.875"
						width="20"
						x="161.25"
						y="29.875"
					/>
					<mask fill="white" id="path-22-inside-2_8021_27248">
						<path d="M12.5 23.625H57.5V143H12.5V23.625Z" />
					</mask>
					<path
						d="M57.1875 23.625V143H57.8125V23.625H57.1875Z"
						fill="#E9EAEB"
						mask="url(#path-22-inside-2_8021_27248)"
					/>
					<rect
						fill="#7F56D9"
						height="3.75"
						rx="1.25"
						width="13.75"
						x="25.625"
						y="30.5"
					/>
					<rect
						fill="#7F56D9"
						height="5"
						rx="2.5"
						width="5"
						x="18.75"
						y="29.875"
					/>
					<rect
						fill="#7F56D9"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="42.375"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="51.125"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="59.875"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="68.625"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="77.375"
					/>
					<rect
						fill="#F5F5F5"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="86.125"
					/>
				</g>
				<rect
					height="129.375"
					rx="4.6875"
					stroke="#D5D7DA"
					strokeWidth="0.625"
					width="174.375"
					x="12.8125"
					y="13.3125"
				/>
			</g>
			<path
				d="M0.5 10.5C0.5 5.25329 4.75329 1 10 1H190C195.247 1 199.5 5.2533 199.5 10.5V122.5C199.5 127.747 195.247 132 190 132H10C4.7533 132 0.5 127.747 0.5 122.5V10.5Z"
				stroke="#D5D7DA"
			/>
		</g>
		<defs>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter0_i_8021_27248"
				width="3.75"
				x="16.875"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27248"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter1_i_8021_27248"
				width="3.75"
				x="23.125"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27248"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter2_i_8021_27248"
				width="3.75"
				x="29.375"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27248"
				/>
			</filter>
			<linearGradient
				gradientUnits="userSpaceOnUse"
				id="paint0_linear_8021_27248"
				x1="52.5"
				x2="52.5"
				y1="0"
				y2="32.5"
			>
				<stop />
				<stop offset="1" stopOpacity="0" />
			</linearGradient>
			<clipPath id="clip0_8021_27248">
				<path
					d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_8021_27248">
				<path
					d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_8021_27248">
				<rect fill="white" height="130" rx="5" width="175" x="12.5" y="13" />
			</clipPath>
		</defs>
	</svg>
);

export const Dark = (props: SVGProps<SVGSVGElement>) => (
	<svg
		className="h-full w-full"
		fill="none"
		viewBox="0 0 200 133"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_8021_27290)">
			<path
				d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
				fill="#F5F5F5"
			/>
			<g clipPath="url(#clip1_8021_27290)">
				<path
					d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
					fill="#22262F"
				/>
				<rect
					fill="#373A41"
					height="1.25001"
					transform="translate(13.125 118) rotate(-90)"
					width="117.5"
				/>
				<rect
					fill="#373A41"
					height="1.25"
					transform="translate(0 13.625)"
					width="200"
				/>
				<rect
					fill="#373A41"
					height="1.25001"
					transform="translate(185.625 118) rotate(-90)"
					width="117.5"
				/>
				<g clipPath="url(#clip2_8021_27290)">
					<rect
						fill="#0C0E12"
						height="130"
						rx="5"
						width="175"
						x="12.5"
						y="13"
					/>
					<mask fill="white" id="path-6-inside-1_8021_27290">
						<path d="M12.5 18C12.5 15.2386 14.7386 13 17.5 13H182.5C185.261 13 187.5 15.2386 187.5 18V23.625H12.5V18Z" />
					</mask>
					<path
						d="M12.5 18C12.5 15.2386 14.7386 13 17.5 13H182.5C185.261 13 187.5 15.2386 187.5 18V23.625H12.5V18Z"
						fill="#13161B"
					/>
					<path
						d="M12.5 13H187.5H12.5ZM187.5 24.25H12.5V23H187.5V24.25ZM12.5 23.625V13V23.625ZM187.5 13V23.625V13Z"
						fill="#373A41"
						mask="url(#path-6-inside-1_8021_27290)"
					/>
					<g filter="url(#filter0_i_8021_27290)">
						<circle cx="18.75" cy="18.625" fill="#EE6A5F" r="1.875" />
					</g>
					<circle
						cx="18.75"
						cy="18.625"
						r="1.79688"
						stroke="#CE5347"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter1_i_8021_27290)">
						<circle cx="25" cy="18.625" fill="#F5BD4F" r="1.875" />
					</g>
					<circle
						cx="25"
						cy="18.625"
						r="1.79688"
						stroke="#D6A243"
						strokeWidth="0.15625"
					/>
					<g filter="url(#filter2_i_8021_27290)">
						<circle cx="31.25" cy="18.625" fill="#61C454" r="1.875" />
					</g>
					<circle
						cx="31.25"
						cy="18.625"
						r="1.79688"
						stroke="#58A942"
						strokeWidth="0.15625"
					/>
					<rect
						fill="#13161B"
						height="45"
						rx="3.75"
						width="117.5"
						x="63.75"
						y="50.8125"
					/>
					<mask
						height="33"
						id="mask0_8021_27290"
						maskUnits="userSpaceOnUse"
						style={{ maskType: "alpha" }}
						width="105"
						x="70"
						y="58"
					>
						<rect
							fill="url(#paint0_linear_8021_27290)"
							height="32.5"
							transform="translate(70 58.3125)"
							width="105"
						/>
					</mask>
					<g mask="url(#mask0_8021_27290)">
						<path
							d="M92.4617 80.6255L81.2734 84.0912C81.253 84.0975 81.2321 84.1017 81.211 84.1037L70.2824 85.1602C70.1222 85.1757 70 85.3103 70 85.4712V87.6875C70 87.8601 70.1399 88 70.3125 88H174.688C174.86 88 175 87.8601 175 87.6875V63.483C175 63.3104 174.86 63.1705 174.688 63.1705H171.303C171.268 63.1705 171.233 63.1646 171.2 63.153L160.128 59.2945C160.046 59.2661 159.957 59.2727 159.88 59.3127L148.793 65.1081C148.765 65.1231 148.734 65.1335 148.702 65.139L137.541 67.0838C137.514 67.0885 137.487 67.0968 137.463 67.1083L126.339 72.2769C126.281 72.3038 126.216 72.3123 126.153 72.3014L115.071 70.3704C115.024 70.3622 114.976 70.3649 114.931 70.3781L103.791 73.613C103.764 73.621 103.738 73.6326 103.714 73.6477L92.5341 80.5925C92.5115 80.6065 92.4871 80.6176 92.4617 80.6255Z"
							fill="#9E77ED"
							opacity="0.1"
						/>
					</g>
					<path
						d="M70 85.1875L81.211 84.1037C81.2321 84.1017 81.253 84.0974 81.2734 84.0912L92.4617 80.6255C92.4871 80.6176 92.5115 80.6065 92.5341 80.5925L103.714 73.6477C103.738 73.6326 103.764 73.621 103.791 73.613L114.931 70.3781C114.976 70.3649 115.024 70.3622 115.071 70.3704L126.154 72.3014C126.216 72.3123 126.281 72.3038 126.339 72.2769L137.463 67.1083C137.487 67.0968 137.514 67.0885 137.541 67.0838L148.702 65.139C148.734 65.1335 148.765 65.1231 148.793 65.1081L159.88 59.3127C159.957 59.2727 160.046 59.2661 160.128 59.2945L171.2 63.153C171.233 63.1646 171.268 63.1705 171.303 63.1705H175"
						stroke="#9E77ED"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="0.625"
					/>
					<path
						d="M63.75 104.562C63.75 102.491 65.4289 100.812 67.5 100.812H177.5C179.571 100.812 181.25 102.491 181.25 104.562V142.062C181.25 144.134 179.571 145.812 177.5 145.812H67.5C65.4289 145.812 63.75 144.134 63.75 142.062V104.562Z"
						fill="#13161B"
					/>
					<rect
						fill="#22262F"
						height="3.75"
						rx="1.25"
						width="65"
						x="63.75"
						y="42.0625"
					/>
					<path
						d="M63.8916 31.875H65.0757L66.2158 34.0283H66.2646L67.4048 31.875H68.5889L66.7651 35.1074V36.875H65.7153V35.1074L63.8916 31.875ZM70.0555 36.9482C69.6763 36.9482 69.3483 36.8677 69.0717 36.7065C68.7966 36.5438 68.5842 36.3175 68.4344 36.0278C68.2847 35.7365 68.2098 35.3988 68.2098 35.0146C68.2098 34.6273 68.2847 34.2887 68.4344 33.999C68.5842 33.7077 68.7966 33.4814 69.0717 33.3203C69.3483 33.1576 69.6763 33.0762 70.0555 33.0762C70.4348 33.0762 70.7619 33.1576 71.037 33.3203C71.3137 33.4814 71.5269 33.7077 71.6766 33.999C71.8264 34.2887 71.9012 34.6273 71.9012 35.0146C71.9012 35.3988 71.8264 35.7365 71.6766 36.0278C71.5269 36.3175 71.3137 36.5438 71.037 36.7065C70.7619 36.8677 70.4348 36.9482 70.0555 36.9482ZM70.0604 36.1426C70.233 36.1426 70.377 36.0937 70.4926 35.9961C70.6081 35.8968 70.6952 35.7617 70.7538 35.5908C70.814 35.4199 70.8441 35.2254 70.8441 35.0073C70.8441 34.7892 70.814 34.5947 70.7538 34.4238C70.6952 34.2529 70.6081 34.1178 70.4926 34.0186C70.377 33.9193 70.233 33.8696 70.0604 33.8696C69.8863 33.8696 69.7398 33.9193 69.621 34.0186C69.5038 34.1178 69.4151 34.2529 69.3549 34.4238C69.2963 34.5947 69.267 34.7892 69.267 35.0073C69.267 35.2254 69.2963 35.4199 69.3549 35.5908C69.4151 35.7617 69.5038 35.8968 69.621 35.9961C69.7398 36.0937 69.8863 36.1426 70.0604 36.1426ZM74.9823 35.2783V33.125H76.0223V36.875H75.0238V36.1938H74.9847C74.9001 36.4136 74.7593 36.5902 74.5624 36.7236C74.3671 36.8571 74.1286 36.9238 73.847 36.9238C73.5964 36.9238 73.3759 36.8669 73.1854 36.7529C72.995 36.639 72.8461 36.4771 72.7386 36.2671C72.6329 36.0571 72.5791 35.8057 72.5775 35.5127V33.125H73.6176V35.3271C73.6192 35.5485 73.6786 35.7235 73.7958 35.8521C73.913 35.9806 74.07 36.0449 74.267 36.0449C74.3923 36.0449 74.5095 36.0164 74.6185 35.9595C74.7276 35.9009 74.8155 35.8146 74.8822 35.7007C74.9506 35.5868 74.9839 35.446 74.9823 35.2783ZM76.8542 36.875V33.125H77.8625V33.7793H77.9016C77.97 33.5465 78.0847 33.3708 78.2458 33.252C78.407 33.1315 78.5925 33.0713 78.8025 33.0713C78.8546 33.0713 78.9107 33.0745 78.9709 33.0811C79.0312 33.0876 79.0841 33.0965 79.1296 33.1079V34.0308C79.0808 34.0161 79.0133 34.0031 78.927 33.9917C78.8407 33.9803 78.7618 33.9746 78.6902 33.9746C78.5372 33.9746 78.4005 34.008 78.28 34.0747C78.1612 34.1398 78.0668 34.231 77.9968 34.3481C77.9285 34.4653 77.8943 34.6004 77.8943 34.7534V36.875H76.8542ZM82.6404 36.936C82.3556 36.936 82.0976 36.8628 81.8665 36.7163C81.637 36.5682 81.4547 36.3509 81.3196 36.0645C81.1861 35.7764 81.1194 35.4232 81.1194 35.0049C81.1194 34.5752 81.1886 34.2179 81.3269 33.9331C81.4653 33.6466 81.6492 33.4326 81.8787 33.291C82.1098 33.1478 82.3629 33.0762 82.6379 33.0762C82.8479 33.0762 83.0229 33.112 83.1628 33.1836C83.3044 33.2536 83.4184 33.3415 83.5046 33.4473C83.5925 33.5514 83.6593 33.654 83.7048 33.7549H83.7366V31.875H84.7742V36.875H83.7488V36.2744H83.7048C83.656 36.3786 83.5868 36.4819 83.4973 36.5845C83.4094 36.6854 83.2947 36.7692 83.1531 36.8359C83.0131 36.9027 82.8422 36.936 82.6404 36.936ZM82.97 36.1084C83.1376 36.1084 83.2792 36.0628 83.3948 35.9717C83.512 35.8789 83.6015 35.7495 83.6633 35.5835C83.7268 35.4175 83.7585 35.223 83.7585 35C83.7585 34.777 83.7276 34.5833 83.6658 34.4189C83.6039 34.2546 83.5144 34.1276 83.3972 34.0381C83.28 33.9486 83.1376 33.9038 82.97 33.9038C82.7991 33.9038 82.655 33.9502 82.5378 34.043C82.4207 34.1357 82.3319 34.2643 82.2717 34.4287C82.2115 34.5931 82.1814 34.7835 82.1814 35C82.1814 35.2181 82.2115 35.411 82.2717 35.5786C82.3336 35.7446 82.4223 35.8748 82.5378 35.9692C82.655 36.062 82.7991 36.1084 82.97 36.1084ZM86.6986 36.9458C86.4594 36.9458 86.2461 36.9043 86.059 36.8213C85.8718 36.7367 85.7237 36.6121 85.6146 36.4478C85.5072 36.2817 85.4535 36.075 85.4535 35.8276C85.4535 35.6193 85.4917 35.4443 85.5682 35.3027C85.6447 35.1611 85.7489 35.0472 85.8807 34.9609C86.0126 34.8747 86.1623 34.8096 86.33 34.7656C86.4992 34.7217 86.6766 34.6908 86.8622 34.6729C87.0803 34.6501 87.2561 34.6289 87.3895 34.6094C87.523 34.5882 87.6198 34.5573 87.6801 34.5166C87.7403 34.4759 87.7704 34.4157 87.7704 34.3359V34.3213C87.7704 34.1667 87.7216 34.047 87.6239 33.9624C87.5279 33.8778 87.3912 33.8354 87.2137 33.8354C87.0266 33.8354 86.8776 33.877 86.767 33.96C86.6563 34.0413 86.583 34.1439 86.5472 34.2676L85.5853 34.1895C85.6342 33.9616 85.7302 33.7646 85.8734 33.5986C86.0166 33.431 86.2014 33.3024 86.4276 33.2129C86.6555 33.1217 86.9191 33.0762 87.2186 33.0762C87.427 33.0762 87.6263 33.1006 87.8168 33.1494C88.0088 33.1982 88.1789 33.2739 88.327 33.3765C88.4768 33.479 88.5948 33.6108 88.681 33.772C88.7673 33.9315 88.8104 34.1227 88.8104 34.3457V36.875H87.8241V36.355H87.7948C87.7346 36.4722 87.654 36.5755 87.5531 36.665C87.4522 36.7529 87.3309 36.8221 87.1893 36.8726C87.0477 36.9214 86.8842 36.9458 86.6986 36.9458ZM86.9965 36.228C87.1495 36.228 87.2845 36.1979 87.4017 36.1377C87.5189 36.0758 87.6109 35.9928 87.6776 35.8887C87.7443 35.7845 87.7777 35.6665 87.7777 35.5347V35.1367C87.7452 35.1579 87.7004 35.1774 87.6434 35.1953C87.5881 35.2116 87.5254 35.2271 87.4554 35.2417C87.3855 35.2547 87.3155 35.2669 87.2455 35.2783C87.1755 35.2881 87.112 35.297 87.0551 35.3052C86.933 35.3231 86.8264 35.3516 86.7352 35.3906C86.6441 35.4297 86.5733 35.4826 86.5228 35.5493C86.4724 35.6144 86.4471 35.6958 86.4471 35.7935C86.4471 35.9351 86.4984 36.0433 86.601 36.1182C86.7051 36.1914 86.837 36.228 86.9965 36.228ZM92.7374 34.1943L91.7853 34.2529C91.769 34.1715 91.734 34.0983 91.6803 34.0332C91.6266 33.9665 91.5558 33.9136 91.4679 33.8745C91.3816 33.8338 91.2783 33.8135 91.1578 33.8135C90.9967 33.8135 90.8608 33.8477 90.7501 33.916C90.6394 33.9827 90.5841 34.0723 90.5841 34.1846C90.5841 34.2741 90.6199 34.3498 90.6915 34.4116C90.7631 34.4735 90.886 34.5231 91.0602 34.5605L91.7389 34.6973C92.1035 34.7721 92.3753 34.8926 92.5543 35.0586C92.7334 35.2246 92.8229 35.4427 92.8229 35.7129C92.8229 35.9587 92.7504 36.1743 92.6056 36.3599C92.4624 36.5454 92.2654 36.6903 92.0148 36.7944C91.7657 36.897 91.4785 36.9482 91.153 36.9482C90.6565 36.9482 90.261 36.8449 89.9664 36.6382C89.6735 36.4299 89.5017 36.1466 89.4513 35.7886L90.4742 35.7349C90.5052 35.8862 90.58 36.0018 90.6989 36.0815C90.8177 36.1597 90.9698 36.1987 91.1554 36.1987C91.3377 36.1987 91.4842 36.1637 91.5948 36.0937C91.7072 36.0221 91.7641 35.9302 91.7657 35.8179C91.7641 35.7235 91.7242 35.6462 91.6461 35.5859C91.568 35.5241 91.4476 35.4769 91.2848 35.4443L90.6354 35.3149C90.2692 35.2417 89.9965 35.1147 89.8175 34.9341C89.6401 34.7534 89.5514 34.5231 89.5514 34.2432C89.5514 34.0023 89.6165 33.7948 89.7467 33.6206C89.8785 33.4465 90.0633 33.3122 90.3009 33.2178C90.5402 33.1234 90.8201 33.0762 91.1407 33.0762C91.6144 33.0762 91.9871 33.1763 92.2589 33.3765C92.5323 33.5767 92.6919 33.8493 92.7374 34.1943ZM94.5178 34.707V36.875H93.4778V31.875H94.4885V33.7866H94.5325C94.6171 33.5653 94.7538 33.3919 94.9426 33.2666C95.1314 33.1396 95.3682 33.0762 95.6531 33.0762C95.9135 33.0762 96.1405 33.1331 96.3342 33.2471C96.5295 33.3594 96.6809 33.5213 96.7883 33.7329C96.8974 33.9429 96.9511 34.1943 96.9495 34.4873V36.875H95.9094V34.6729C95.9111 34.4417 95.8525 34.2619 95.7336 34.1333C95.6165 34.0047 95.4521 33.9404 95.2405 33.9404C95.0989 33.9404 94.9736 33.9705 94.8645 34.0308C94.7571 34.091 94.6724 34.1789 94.6106 34.2944C94.5504 34.4084 94.5194 34.5459 94.5178 34.707ZM97.7875 36.875V31.875H98.8275V33.7549H98.8593C98.9048 33.654 98.9707 33.5514 99.057 33.4473C99.1449 33.3415 99.2588 33.2536 99.3988 33.1836C99.5404 33.112 99.7162 33.0762 99.9261 33.0762C100.2 33.0762 100.452 33.1478 100.683 33.291C100.914 33.4326 101.099 33.6466 101.237 33.9331C101.376 34.2179 101.445 34.5752 101.445 35.0049C101.445 35.4232 101.377 35.7764 101.242 36.0645C101.109 36.3509 100.926 36.5682 100.695 36.7163C100.466 36.8628 100.209 36.936 99.9237 36.936C99.7219 36.936 99.5502 36.9027 99.4086 36.8359C99.2686 36.7692 99.1538 36.6854 99.0643 36.5845C98.9748 36.4819 98.9065 36.3786 98.8593 36.2744H98.8129V36.875H97.7875ZM98.8055 35C98.8055 35.223 98.8365 35.4175 98.8983 35.5835C98.9602 35.7495 99.0497 35.8789 99.1669 35.9717C99.2841 36.0628 99.4265 36.1084 99.5941 36.1084C99.7634 36.1084 99.9066 36.062 100.024 35.9692C100.141 35.8748 100.23 35.7446 100.29 35.5786C100.352 35.411 100.383 35.2181 100.383 35C100.383 34.7835 100.353 34.5931 100.292 34.4287C100.232 34.2643 100.143 34.1357 100.026 34.043C99.9091 33.9502 99.765 33.9038 99.5941 33.9038C99.4248 33.9038 99.2816 33.9486 99.1644 34.0381C99.0489 34.1276 98.9602 34.2546 98.8983 34.4189C98.8365 34.5833 98.8055 34.777 98.8055 35ZM103.833 36.9482C103.454 36.9482 103.126 36.8677 102.849 36.7065C102.574 36.5438 102.362 36.3175 102.212 36.0278C102.062 35.7365 101.987 35.3988 101.987 35.0146C101.987 34.6273 102.062 34.2887 102.212 33.999C102.362 33.7077 102.574 33.4814 102.849 33.3203C103.126 33.1576 103.454 33.0762 103.833 33.0762C104.212 33.0762 104.539 33.1576 104.814 33.3203C105.091 33.4814 105.304 33.7077 105.454 33.999C105.604 34.2887 105.679 34.6273 105.679 35.0146C105.679 35.3988 105.604 35.7365 105.454 36.0278C105.304 36.3175 105.091 36.5438 104.814 36.7065C104.539 36.8677 104.212 36.9482 103.833 36.9482ZM103.838 36.1426C104.01 36.1426 104.154 36.0937 104.27 35.9961C104.386 35.8968 104.473 35.7617 104.531 35.5908C104.591 35.4199 104.622 35.2254 104.622 35.0073C104.622 34.7892 104.591 34.5947 104.531 34.4238C104.473 34.2529 104.386 34.1178 104.27 34.0186C104.154 33.9193 104.01 33.8696 103.838 33.8696C103.664 33.8696 103.517 33.9193 103.398 34.0186C103.281 34.1178 103.193 34.2529 103.132 34.4238C103.074 34.5947 103.044 34.7892 103.044 35.0073C103.044 35.2254 103.074 35.4199 103.132 35.5908C103.193 35.7617 103.281 35.8968 103.398 35.9961C103.517 36.0937 103.664 36.1426 103.838 36.1426ZM107.424 36.9458C107.185 36.9458 106.972 36.9043 106.785 36.8213C106.597 36.7367 106.449 36.6121 106.34 36.4478C106.233 36.2817 106.179 36.075 106.179 35.8276C106.179 35.6193 106.217 35.4443 106.294 35.3027C106.37 35.1611 106.475 35.0472 106.606 34.9609C106.738 34.8747 106.888 34.8096 107.056 34.7656C107.225 34.7217 107.402 34.6908 107.588 34.6729C107.806 34.6501 107.982 34.6289 108.115 34.6094C108.249 34.5882 108.346 34.5573 108.406 34.5166C108.466 34.4759 108.496 34.4157 108.496 34.3359V34.3213C108.496 34.1667 108.447 34.047 108.35 33.9624C108.254 33.8778 108.117 33.8354 107.939 33.8354C107.752 33.8354 107.603 33.877 107.493 33.96C107.382 34.0413 107.309 34.1439 107.273 34.2676L106.311 34.1895C106.36 33.9616 106.456 33.7646 106.599 33.5986C106.742 33.431 106.927 33.3024 107.153 33.2129C107.381 33.1217 107.645 33.0762 107.944 33.0762C108.153 33.0762 108.352 33.1006 108.542 33.1494C108.735 33.1982 108.905 33.2739 109.053 33.3765C109.202 33.479 109.32 33.6108 109.407 33.772C109.493 33.9315 109.536 34.1227 109.536 34.3457V36.875H108.55V36.355H108.521C108.46 36.4722 108.38 36.5755 108.279 36.665C108.178 36.7529 108.057 36.8221 107.915 36.8726C107.773 36.9214 107.61 36.9458 107.424 36.9458ZM107.722 36.228C107.875 36.228 108.01 36.1979 108.127 36.1377C108.245 36.0758 108.337 35.9928 108.403 35.8887C108.47 35.7845 108.503 35.6665 108.503 35.5347V35.1367C108.471 35.1579 108.426 35.1774 108.369 35.1953C108.314 35.2116 108.251 35.2271 108.181 35.2417C108.111 35.2547 108.041 35.2669 107.971 35.2783C107.901 35.2881 107.838 35.297 107.781 35.3052C107.659 35.3231 107.552 35.3516 107.461 35.3906C107.37 35.4297 107.299 35.4826 107.249 35.5493C107.198 35.6144 107.173 35.6958 107.173 35.7935C107.173 35.9351 107.224 36.0433 107.327 36.1182C107.431 36.1914 107.563 36.228 107.722 36.228ZM110.343 36.875V33.125H111.351V33.7793H111.39C111.459 33.5465 111.573 33.3708 111.735 33.252C111.896 33.1315 112.081 33.0713 112.291 33.0713C112.343 33.0713 112.399 33.0745 112.46 33.0811C112.52 33.0876 112.573 33.0965 112.618 33.1079V34.0308C112.57 34.0161 112.502 34.0031 112.416 33.9917C112.33 33.9803 112.251 33.9746 112.179 33.9746C112.026 33.9746 111.889 34.008 111.769 34.0747C111.65 34.1398 111.556 34.231 111.486 34.3481C111.417 34.4653 111.383 34.6004 111.383 34.7534V36.875H110.343ZM114.363 36.936C114.079 36.936 113.821 36.8628 113.589 36.7163C113.36 36.5682 113.178 36.3509 113.043 36.0645C112.909 35.7764 112.842 35.4232 112.842 35.0049C112.842 34.5752 112.912 34.2179 113.05 33.9331C113.188 33.6466 113.372 33.4326 113.602 33.291C113.833 33.1478 114.086 33.0762 114.361 33.0762C114.571 33.0762 114.746 33.112 114.886 33.1836C115.027 33.2536 115.141 33.3415 115.228 33.4473C115.316 33.5514 115.382 33.654 115.428 33.7549H115.46V31.875H116.497V36.875H115.472V36.2744H115.428C115.379 36.3786 115.31 36.4819 115.22 36.5845C115.132 36.6854 115.018 36.7692 114.876 36.8359C114.736 36.9027 114.565 36.936 114.363 36.936ZM114.693 36.1084C114.861 36.1084 115.002 36.0628 115.118 35.9717C115.235 35.8789 115.325 35.7495 115.386 35.5835C115.45 35.4175 115.482 35.223 115.482 35C115.482 34.777 115.451 34.5833 115.389 34.4189C115.327 34.2546 115.237 34.1276 115.12 34.0381C115.003 33.9486 114.861 33.9038 114.693 33.9038C114.522 33.9038 114.378 33.9502 114.261 34.043C114.144 34.1357 114.055 34.2643 113.995 34.4287C113.935 34.5931 113.904 34.7835 113.904 35C113.904 35.2181 113.935 35.411 113.995 35.5786C114.057 35.7446 114.145 35.8748 114.261 35.9692C114.378 36.062 114.522 36.1084 114.693 36.1084Z"
						fill="#F7F7F7"
					/>
					<rect
						fill="#22262F"
						height="6.875"
						rx="1.875"
						width="20"
						x="138.125"
						y="29.875"
					/>
					<rect
						fill="#373A41"
						height="6.875"
						rx="1.875"
						width="20"
						x="161.25"
						y="29.875"
					/>
					<mask fill="white" id="path-22-inside-2_8021_27290">
						<path d="M12.5 23.625H57.5V143H12.5V23.625Z" />
					</mask>
					<path
						d="M57.1875 23.625V143H57.8125V23.625H57.1875Z"
						fill="#22262F"
						mask="url(#path-22-inside-2_8021_27290)"
					/>
					<rect
						fill="#373A41"
						height="3.75"
						rx="1.25"
						width="13.75"
						x="25.625"
						y="30.5"
					/>
					<rect
						fill="#373A41"
						height="5"
						rx="2.5"
						width="5"
						x="18.75"
						y="29.875"
					/>
					<rect
						fill="#373A41"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="42.375"
					/>
					<rect
						fill="#22262F"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="51.125"
					/>
					<rect
						fill="#22262F"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="59.875"
					/>
					<rect
						fill="#22262F"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="68.625"
					/>
					<rect
						fill="#22262F"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="77.375"
					/>
					<rect
						fill="#22262F"
						height="5"
						rx="1.25"
						width="27.5"
						x="18.75"
						y="86.125"
					/>
				</g>
				<rect
					height="129.375"
					rx="4.6875"
					stroke="#373A41"
					strokeWidth="0.625"
					width="174.375"
					x="12.8125"
					y="13.3125"
				/>
			</g>
			<path
				d="M0.5 10.5C0.5 5.25329 4.75329 1 10 1H190C195.247 1 199.5 5.2533 199.5 10.5V122.5C199.5 127.747 195.247 132 190 132H10C4.7533 132 0.5 127.747 0.5 122.5V10.5Z"
				stroke="#373A41"
			/>
		</g>
		<defs>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter0_i_8021_27290"
				width="3.75"
				x="16.875"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27290"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter1_i_8021_27290"
				width="3.75"
				x="23.125"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27290"
				/>
			</filter>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="3.75"
				id="filter2_i_8021_27290"
				width="3.75"
				x="29.375"
				y="16.75"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					in="SourceGraphic"
					in2="BackgroundImageFix"
					mode="normal"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.9375" />
				<feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
				/>
				<feBlend
					in2="shape"
					mode="normal"
					result="effect1_innerShadow_8021_27290"
				/>
			</filter>
			<linearGradient
				gradientUnits="userSpaceOnUse"
				id="paint0_linear_8021_27290"
				x1="52.5"
				x2="52.5"
				y1="0"
				y2="32.5"
			>
				<stop />
				<stop offset="1" stopOpacity="0" />
			</linearGradient>
			<clipPath id="clip0_8021_27290">
				<path
					d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_8021_27290">
				<path
					d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H190C195.523 0.5 200 4.97715 200 10.5V122.5C200 128.023 195.523 132.5 190 132.5H10C4.47716 132.5 0 128.023 0 122.5V10.5Z"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_8021_27290">
				<rect fill="white" height="130" rx="5" width="175" x="12.5" y="13" />
			</clipPath>
		</defs>
	</svg>
);
